import { Component, OnInit, Inject, ViewChild, ElementRef, Output, EventEmitter, OnDestroy, ChangeDetectorRef, Input } from '@angular/core';
import { MatButton, MatDialogConfig, MatInput, MatList, MatRadioChange } from '@angular/material';
import { DashboardDialogComponent, DashboardDialogProjectNotif } from 'src/app/components/dashboard-menu/dashboard-menu.component';
import { MessageService } from 'src/app/services/message/message.service';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { Validators, FormControl, FormGroup, FormBuilder} from '@angular/forms';
import { environment } from '../../../../environments/environment';
import { debounceTime, map, switchMap } from 'rxjs/operators';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription, Subject, forkJoin, Observable } from 'rxjs';
import {MatStepper} from '@angular/material';
import { MatMenu } from '@angular/material/menu';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe, Location } from "@angular/common";
import * as introJs from 'intro.js/intro.js';
import { ProfileupdDialog, projectInfoDialog } from '../single-project/single-project.component';
import { takeUntil } from 'rxjs/operators';
import { addMemberCompany } from 'src/app/company-member/company-member.component';
import { ConditionalExpr } from '@angular/compiler';
import { SocketService } from 'src/app/services/socket/socket.service';
import { Event } from 'src/app/services/socket/model/event';import { Message } from 'src/app/services/socket/model/message';
import { ActivatedRouteSnapshot } from '@angular/router';
import { PerfectScrollbarComponent } from 'ngx-perfect-scrollbar';
import { LoadingScreenService } from 'src/app/services/loading-screen/loading-screen.service';
import { v4 as uuidv4 } from 'uuid';
import { croppedimagedialog } from 'src/app/pages/profile/profile.component';
import { ShareDialogComponent } from './sharedialog.component';
import { ConfirmdialogComponent } from '../confirmdialog/confirmdialog.component';
import { PackComponent } from '../pack/pack.component';
import { DomainConfigService } from 'src/app/services/translate/domain-config.service';
import { ProjectStateService } from 'src/app/services/project-state.service';
import * as moment from 'moment';


export interface Projects {
  name: string;
  date: string;
  groupName: string;
  url: string;
}

export interface DialogData {
  objectif: string;
  projetName: string;
  projects: Array<any>;
}


@Component({
  selector: 'app-dashboardnav',
  templateUrl: './dashboardnav.component.html',
  styleUrls: ['./dashboardnav.component.scss']
})
export class DashboardnavComponent implements OnInit, OnDestroy {

  introJS = introJs();

  NOTIF_ALL_ENABLE: boolean = false;
  NOTIF_INV_EMAIL: boolean = true;
  NOTIF_INV_PUSH: boolean = true;
  NOTIF_INV_SON: boolean = true;
  NOTIF_INSTANT_EMAIL: boolean = true;
  NOTIF_INSTANT_PUSH: boolean = true;
  NOTIF_INSTANT_SON: boolean = true;
  NOTIF_STRUCT_REC_EMAIL: boolean = true;
  NOTIF_STRUCT_REC_PUSH: boolean = true;
  NOTIF_STRUCT_REC_SON: boolean = true;
  NOTIF_STRUCT_COPY_EMAIL: boolean = true;
  NOTIF_STRUCT_COPY_PUSH: boolean = true;
  NOTIF_STRUCT_COPY_SON: boolean = true;
  NOTIF_STRUCT_COM_EMAIL: boolean = true;
  NOTIF_STRUCT_COM_PUSH: boolean = true;
  NOTIF_STRUCT_COM_SON: boolean = true;

  ngOnDestroy(): void {
    //this.subscription.unsubscribe();
  }

  subscription: Subscription;
  projects: Array<any> = [];
  projectLists: Array<any> = [];
  displayedProjects: Array<any> = [];
  pageSearch = 1;
  projectsIds: Array<any> = [];
  new_message: boolean = false;
  total_notif: number = 0;
  total_notif_instant: number = 0;
  total_notif_struct: number = 0;
  new_invitation: boolean = false;
  new_coadmin: boolean = false;
  new_message_instant: boolean = false;
  prob_cnx: boolean = false; 
  text_baniere = "New interaction(s) received nav";
  text_baniere_body = "";
  text_baniere_instant = "New interaction(s) received nav";
  text_baniere_instant_body = "";
  text_baniere_title = "";
  text_baniere_type = "";
  text_baniere_sujet = "";
  text_baniere_format = "";
  text_baniere_msg = "un message";
  text_baniere_cmn = "un commentaire";
  ban_type = null; 
  ban_proj = null; 
  ban_msg = null; 
  ifme = null;
  projectListsParent: Array<any> = [];
  total_project = 0;
  actif_project = 0;
  archived_project = 0;
  stat_projects = 0;
  stat_documents = 0;
  stat_exchanges = 0;
  stat_tasks = 0;
  init_total_project = 0;
  name: any;
  profile: any;
  commonRef: any;
  notificationload: any;
  //dialog: any;
  token: any;
  objectif: string;
  projetName: string;
  currentProjectId: string;
  projectId: string;
  currentProj : any;
  searchProject : any = null;
  currentUser: any;
  adminrole = false;
  lang = 'fr';
  displayedColumns: string[] = ['Columnsproject'];
  intro = null;
  stepProject = null;
  stepContact = null;
  stepNotif = null;
  stepInvit = null;
  stepBoard = null;
  skipLabel= null;
  doneLabel= null;
  prevLabel= null;
  nextLabel= null;
  showTool = false;
  inProject = false;
  inFace = false;
  route: string;
  userData : any;
  isCurrentuser:boolean = true;
  Url = environment.server_url
  profileImg : any
  @ViewChild('faceAndyouGroups', {static: true}) projectListDiv: ElementRef;
  //@ViewChild('allproject', {static: false}) allproject: ElementRef;
  @ViewChild('scrollMeproj', { static: false }) scrollMeproj: ElementRef;
  @ViewChild('scrollMeprojsearch', { static: false }) scrollMeprojsearch: ElementRef;
  isdataloaded = false;
  canloadagain = true;
  isdataloadedsearch = false;
  canloadagainsearch = true;
  nbrloadmsg = 0;
  pageIndex = 1;
  loadingMessagesTop = false;
  perPage = 20;
  startedPoint = false;
  canload = false;
  scrollposition = 0;
  scrollpositionsearch = 0;
  page = 1;
  updclicked = false;
  projectFull: any;
  secteur = "";
  ioConnection: any;
  socket_service_connection: Subscription;
  socket_service_onMessage: Subscription;
  projectMap = new Map<string, number>();
  projectMapFace = new Map<string, number>();
  filterRead = localStorage.getItem('notified');
  archiveMode = false;
  private subscribedGroups: string[] = [];
  showtooltip = false;
  showtooltiplang = 0;
  private searchTerms = new Subject<string>();
  lang_site = "en";
  lang_discuss = "en";
  autoTranslate: boolean = true;
  searchControl = new FormControl();
  searchControlSite = new FormControl();
  private initExecuted = false;
  requestDataSent = false;
  requestData = null;
  requestDataPath = null;
  totalNotAnswered = 0;
  textSupport = "";
  showMessage = false;
  isKevin = false;

  /*vibrantColors = [
    "#FF5733", // Rouge vif
    "#FF8D1A", // Orange vif
    "#F9C74F", // Jaune doré
    "#4CAF50", // Vert
    "#D32F2F", // Rouge profond
    "#9C27B0", // Violet
    "#E91E63", // Rose
    "#FFEB3B", // Jaune
    "#00BCD4", // Bleu clair
    "#8BC34A", // Vert lime
    "#FF5722", // Orange foncé
    "#3F51B5", // Bleu indigo
    "#9E9D24", // Jaune-vert
    "#F44336", // Rouge éclatant
    "#00C853", // Vert vif
    "#9E1B32", // Rouge sombre
    "#F50057", // Rose fuchsia
    "#FF7043", // Orange corail
    "#8E24AA", // Violet intense
    "#388E3C"  // Vert forêt
  ];*/
  
  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };

  // Liste des langues (en fonction de votre besoin, vous pouvez l'extraire depuis une API ou la définir ici)
  languagessite = [
    { code: 'en', name: 'Anglais', image: 'https://flagcdn.com/w320/us.png' },
    //{ code: 'es', name: 'Espagnol', image: 'https://flagcdn.com/w320/es.png' },
    { code: 'fr', name: 'Français', image: 'https://flagcdn.com/w320/fr.png' }
  ]
  languages = [
    { code: 'af', name: 'Afrikaans', image: 'https://flagcdn.com/w320/za.png' },
    { code: 'sq', name: 'Albanais', image: 'https://flagcdn.com/w320/al.png' },
    { code: 'de', name: 'Allemand', image: 'https://flagcdn.com/w320/de.png' },
    { code: 'am', name: 'Amharique', image: 'https://flagcdn.com/w320/et.png' },
    { code: 'en', name: 'Anglais', image: 'https://flagcdn.com/w320/us.png' },
    { code: 'ar', name: 'Arabe', image: 'https://flagcdn.com/w320/sa.png' },
    { code: 'hy', name: 'Arménien', image: 'https://flagcdn.com/w320/am.png' },
    { code: 'bn', name: 'Bengali', image: 'https://flagcdn.com/w320/bd.png' },
    { code: 'bs', name: 'Bosnien', image: 'https://flagcdn.com/w320/ba.png' },
    { code: 'bg', name: 'Bulgare', image: 'https://flagcdn.com/w320/bg.png' },
    { code: 'ca', name: 'Catalan', image: 'https://flagcdn.com/w320/es.png' },
    { code: 'zh-CN', name: 'Chinois simplifié', image: 'https://flagcdn.com/w320/cn.png' },
    { code: 'zh-TW', name: 'Chinois traditionnel', image: 'https://flagcdn.com/w320/tw.png' },
    { code: 'ko', name: 'Coréen', image: 'https://flagcdn.com/w320/kr.png' },
    { code: 'hr', name: 'Croate', image: 'https://flagcdn.com/w320/hr.png' },
    { code: 'da', name: 'Danois', image: 'https://flagcdn.com/w320/dk.png' },
    { code: 'es', name: 'Espagnol', image: 'https://flagcdn.com/w320/es.png' },
    { code: 'eo', name: 'Espéranto', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/f5/Flag_of_Esperanto.svg/langfr-225px-Flag_of_Esperanto.svg.png' }, // Pas de drapeau spécifique pour l'Espéranto
    { code: 'et', name: 'Estonien', image: 'https://flagcdn.com/w320/ee.png' },
    { code: 'tl', name: 'Filipino', image: 'https://flagcdn.com/w320/ph.png' },
    { code: 'fi', name: 'Finnois', image: 'https://flagcdn.com/w320/fi.png' },
    { code: 'fr', name: 'Français', image: 'https://flagcdn.com/w320/fr.png' },
    { code: 'cy', name: 'Gallois', image: 'https://flagcdn.com/w320/gb.png' },
    { code: 'ka', name: 'Géorgien', image: 'https://flagcdn.com/w320/ge.png' },
    { code: 'el', name: 'Grec', image: 'https://flagcdn.com/w320/gr.png' },
    { code: 'gu', name: 'Gujarati', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'hi', name: 'Hindi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'he', name: 'Hébreu', image: 'https://flagcdn.com/w320/il.png' },
    { code: 'hu', name: 'Hongrois', image: 'https://flagcdn.com/w320/hu.png' },
    { code: 'is', name: 'Islandais', image: 'https://flagcdn.com/w320/is.png' },
    { code: 'it', name: 'Italien', image: 'https://flagcdn.com/w320/it.png' },
    { code: 'ja', name: 'Japonais', image: 'https://flagcdn.com/w320/jp.png' },
    { code: 'jw', name: 'Javanais', image: 'https://flagcdn.com/w320/id.png' },
    { code: 'km', name: 'Khmer', image: 'https://flagcdn.com/w320/kh.png' },
    { code: 'la', name: 'Latin', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bc/Latin_Empire_Flag.svg/800px-Latin_Empire_Flag.svg.png' }, // Pas de drapeau spécifique pour le Latin
    { code: 'lv', name: 'Letton', image: 'https://flagcdn.com/w320/lv.png' },
    { code: 'lt', name: 'Lituanien', image: 'https://flagcdn.com/w320/lt.png' },
    { code: 'ml', name: 'Malayalam', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'mr', name: 'Marathi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'nl', name: 'Néerlandais', image: 'https://flagcdn.com/w320/nl.png' },
    { code: 'ne', name: 'Népalais', image: 'https://flagcdn.com/w320/np.png' },
    { code: 'no', name: 'Norvégien', image: 'https://flagcdn.com/w320/no.png' },
    { code: 'pl', name: 'Polonais', image: 'https://flagcdn.com/w320/pl.png' },
    { code: 'pt', name: 'Portugais', image: 'https://flagcdn.com/w320/pt.png' },
    { code: 'pa', name: 'Punjabi', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'ro', name: 'Roumain', image: 'https://flagcdn.com/w320/ro.png' },
    { code: 'ru', name: 'Russe', image: 'https://flagcdn.com/w320/ru.png' },
    { code: 'sr', name: 'Serbe', image: 'https://flagcdn.com/w320/rs.png' },
    { code: 'si', name: 'Sinhala', image: 'https://flagcdn.com/w320/lk.png' },
    { code: 'sk', name: 'Slovaque', image: 'https://flagcdn.com/w320/sk.png' },
    { code: 'sl', name: 'Slovène', image: 'https://flagcdn.com/w320/si.png' },
    { code: 'su', name: 'Sundanese', image: 'https://flagcdn.com/w320/id.png' },
    { code: 'sv', name: 'Suédois', image: 'https://flagcdn.com/w320/se.png' },
    { code: 'sw', name: 'Swahili', image: 'https://flagcdn.com/w320/ke.png' },
    { code: 'ta', name: 'Tamoul', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'cs', name: 'Tchèque', image: 'https://flagcdn.com/w320/cz.png' },
    { code: 'te', name: 'Télougou', image: 'https://flagcdn.com/w320/in.png' },
    { code: 'th', name: 'Thaïlandais', image: 'https://flagcdn.com/w320/th.png' },
    { code: 'tr', name: 'Turc', image: 'https://flagcdn.com/w320/tr.png' },
    { code: 'uk', name: 'Ukrainien', image: 'https://flagcdn.com/w320/ua.png' },
    { code: 'ur', name: 'Urdu', image: 'https://flagcdn.com/w320/pk.png' },
    { code: 'vi', name: 'Vietnamien', image: 'https://flagcdn.com/w320/vn.png' },
    { code: 'wo', name: 'Wolof', image: 'https://flagcdn.com/w320/sn.png' },
    { code: 'xh', name: 'Xhosa', image: 'https://flagcdn.com/w320/za.png' },
    { code: 'yi', name: 'Yiddish', image: 'https://flagcdn.com/w320/il.png' },
    { code: 'zu', name: 'Zoulou', image: 'https://flagcdn.com/w320/za.png' }
];



  // Liste filtrée des langues
  filteredLanguages = this.languages;
  filteredLanguagessite = this.languagessite;

  @Output() projectChosen = new EventEmitter();
  @Output() notifChanged = new EventEmitter();
  @Output() projectChanged = new EventEmitter();
  @Output() imageChanged = new EventEmitter();
  @Input() ongletId: string;
  createproject = null;
  imageFil = null;
  edit = false;
  fname = '';
  lname = '';
  dob = '';
  datebirth = '';
  jobT = '';
  email = '';
  gender = 'male';
  description = '';
  phone = '';
  oldPassword = '';
  newPassword = '';
  img: any;
  idUser = null;
  contactInfo: any;
  public typingDots: string = '';
  typingUser = null;
  showDropdown: boolean = false;
  private typingTimeout: any = null;
  //firstConnection = localStorage.getItem('firstConnection');
  private dialogRef: MatDialogRef<PackComponent> | null = null;

  private standardClientOptions: string[] = ['espace d\'échange', 'projet', 'groupe', 'workspace', 'franchisé'];
  private standardMissionOptions: string[] = ['canal', 'mission', 'sujet', 'sous-groupe', 'canal'];

  selectedClient: string = 'projet'; // Valeur par défaut
  selectedMission: string = 'sujet'; // Valeur par défaut

  // Variables pour stocker la saisie 'Autre...'
  customClientName: string = '';
  customMissionName: string = '';
  dbClientName: string = '';
  dbMissionName: string = '';
  hasCustomClientLabel: boolean = false;
  hasCustomMissionLabel: boolean = false;
  activeStep = 0;
  isVisible = true;

  constructor(
    public dialog: MatDialog,
    private authServices: AuthService, 
    private router: Router, 
    private routeAc: ActivatedRoute,
    private interceptor: LoadingScreenService,
    private translate: TranslateService,
    private cdr: ChangeDetectorRef,
    location: Location, 
    public datepipe: DatePipe,
    private messageService: MessageService,
    private domainConfig: DomainConfigService,
    private projectState: ProjectStateService,
    //private routersnap: ActivatedRoute,
    private socketService: SocketService) {
      this.filterRead = this.messageService.getFilterNav();
    
    
      this.loadProject();
      this.countNotif();
    this.secteur = localStorage.getItem('secteur');
    this.currentUser = JSON.parse(localStorage.getItem('currentUser'))['id'];
    this.userData = JSON.parse(localStorage.getItem('currentUser'));
    this.loadUserPreferences();
    this.isCurrentuser = (this.userData.id == this.idUser || this.idUser == null) ? true : false;
      if(this.idUser)
        {
          this.getCurrentUser();
        } else {
          this.getMyInfo();
      }
    if(this.userData.imageUrl){
      this.profileImg = this.Url + this.userData.imageUrl
    }
    this.isKevin = (this.userData.compId === 'dd07b344-c538-4e73-9cfa-e6e66cc0cce4');
    this.authServices.obProjetAdded.subscribe((result: any) =>{
      const id = result.id;
      this.authServices.getTheProject(id).subscribe((res)=>{
        res['userProject'] = res['userProject'].filter(userProject => {
          return userProject.user && userProject.user.id === this.currentUser;
        });
        const exists = this.projectLists.some(project => project.id === id);
        if (!exists) {
          this.projectLists.unshift(res);
          this.init_total_project++;
          if(this.filterRead == 'all') this.total_project = this.init_total_project;
          const bgColor = this.getRandomColor();
          this.projectLists[0].randomColor = bgColor;
          this.projectLists[0].textColor = this.darkenColor(this.projectLists[0].color);
        }
        //this.projectLists.unshift(res);
        this.perPage += 1;
        this.projectLists[0].userProject.filter(userProject => {
          return userProject.user && userProject.user.id === this.currentUser;
        });
        this.projectMapFace[id]=0;
        this.initIoConnection(id);
        this.messageService.setProjectMapFace(this.projectMapFace);
        this.messageService.setListProject(this.projectLists);
    })
  })
    this.authServices.obRefreshProjet.subscribe(() =>{
      console.log("refresh load")
      this.loadProject();
    });
    

    /*
    this.subscription = this.messageService.getMessage().subscribe(() => { 
      this.loadNotifProjet();
    });*/
    this.messageService.obdisableMessage.subscribe((idProject: any) => {
        this.updateProjectNotifications(idProject).subscribe((total) => {
          this.projectMapFace[idProject]=total;
          this.projectLists.filter(item => item.id == idProject)[0].userProject[0].face = total;
        })
        this.updateHeaderNotifs();
    });
    
    
    this.setVar();
    this.setTheGuide();
    this.messageService.getTranslate().subscribe((data) => {
      this.setVar();
      this.setTheGuide();
    });
    

    this.messageService.getGuide().subscribe(() => { 
      this.introJS.start().oncomplete(function() {
        window.localStorage['guide'] = 1;
      });
    });
    
    if (this.messageService.getShowCreateProjectTuto() == true) {
      this.showTool = true; 
    }
    
    this.messageService.getMessageIsSend().subscribe(() => {
       this.showTool = false; 
       this.messageService.setShowCreateProjectTuto(false);
    });

    this.interceptor.getCnx().subscribe((isOffline) => {
      if (isOffline) {
        this.ban_type = "connexion";
        this.text_baniere_title ="Problème de connexion";
        this.text_baniere = "vous avez un problème de connexion"; 
        this.prob_cnx = true;
      } else {
      }
    });

  }

  changeArchiveProjects(){
    this.archiveMode = !this.archiveMode;
    if(this.archiveMode){
      this.filterRead = "all";
      this.loadArchivedProjects(true);
    } else {
      this.filterRead = "all";
      this.total_project = this.init_total_project;
      this.loadPartProjects(true);
    }
  }

  loadArchivedProjects(loaded = null) {
      var progress = 0;
      var start = 0;
      if(this.projectLists.length > 0 && !loaded){
        this.perPage = this.projectLists.length;
        start = this.perPage;
        this.pageIndex = 2;
        this.loadingMessagesTop = true;
      } else this.projectLists = [];
      //var uri = '/projects?perPage='+this.perPage+'&page='+this.pageIndex+'&order[motionAt]=desc';
      var uri = '/archived-projects?limit='+this.perPage+'&offset='+start+'&order[motionAt]=desc';
      this.authServices.getArchivedProjects(uri).subscribe(res => {
        var result = res['hydra:member'];
        var lengthresults = res['hydra:totalItems'] ;
        progress += 5;  // 100 / 20
        if(lengthresults == 0 && this.pageIndex == 1) this.authServices.endLoading.next("1");
        const observables = result.map((value, index) => {
          return new Observable((observer) => {
            value.userProject = value.userProject.filter(userProject => {
              return userProject.user && userProject.user.id === this.currentUser;
            });
            this.projectMapFace[value.id]=value.userProject[0].face;
            if(this.pageIndex === 1) this.authServices.updateProgress(progress);
              observer.next(); // Signaler la fin de l'observable
              observer.complete();
          });
        });
        forkJoin(observables).subscribe(() => {
          this.loadingMessagesTop = false;
          this.authServices.endLoading.next("1");
          if(loaded) this.projectLists = [];
          this.projectLists = this.projectLists.concat(result);
          this.projectLists.forEach(project => {
            const bgColor = this.getRandomColor();
            project.randomColor = bgColor;
            project.textColor = this.darkenColor(project.color);
          });
          this.messageService.setListProject(this.projectLists);
          this.messageService.setProjectMapFace(this.projectMapFace);
          this.calculateTotalNotifications();
          this.isdataloaded == false;
          if(!result || result.length == 0 || result.length < this.perPage) this.canloadagain = false;
          setTimeout(() => {
            this.restoreScrollPosition();
          }, 0);
        });
      });
  }

  archiveProject(id, libelle) {
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
           data: { 
             message: 'Voulez vraiment archiver le projet '+libelle,
             title: 'Confirmation'
           },
           panelClass: 'confirmclass',
           backdropClass: 'custom-backdrop'
         });
     
         dialogRef.afterClosed().subscribe(result => {
           if (result) {
            this.onClickConfirmeArchive(id, libelle);
           } else {
             //console.log('L\'utilisateur a annulé la suppression');
           }
    });
  }

  onClickConfirmeArchive(id, libelle): void{
    this.authServices.archiveProject(id).subscribe(
      res => {  
        this.actif_project -= 1;
        this.archived_project += 1;
        this.perPage -= 1;
        this.socketService.sendInstant({
            id: id,
            action: id,
            type: "ARCHIVEPROJECT",
            author: this.userData.fullName,
            recipient: this.userData.id,
            text: '',
            copy: "",
            private: false,
            res: "",
            project_lib: libelle,
            date: ""
        });
        this.init_total_project--;
        if(this.filterRead == 'all') this.total_project = this.init_total_project
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  desarchiveProject(id, libelle) {
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
           data: { 
             message: 'Voulez vraiment désarchiver le projet '+libelle,
             title: 'Confirmation'
           },
           panelClass: 'confirmclass',
           backdropClass: 'custom-backdrop'
         });
     
         dialogRef.afterClosed().subscribe(result => {
           if (result) {
            this.onClickConfirmeDesarchive(id, libelle);
           } else {
             //console.log('L\'utilisateur a annulé la suppression');
           }
    });
  }

  onClickConfirmeDesarchive(id, libelle): void{
    this.authServices.desarchiveProject(id).subscribe(
      res => {  
        this.actif_project += 1;
        this.archived_project -= 1;
        this.perPage -= 1;
        this.socketService.sendInstant({
            id: id,
            action: id,
            type: "UNARCHIVEPROJECT",
            author: this.userData.fullName,
            recipient: this.userData.id,
            text: '',
            copy: "",
            private: false,
            res: "",
            project_lib: libelle,
            date: ""
        });
        this.init_total_project--;
        if(this.filterRead == 'all') this.total_project = this.init_total_project
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  

  showProject(project: any): void{
    if (project){ 
      console.log("cliiiicked : "+project.id)
      this.fctprojectChosen(project.id, project.libelle, project.imageUrl, project);
    } 
  }

  loadUserPreferences(): void {
        // 1. Récupération des valeurs du localStorage
        const storedClient = this.userData.comProject;
        const storedMission = this.userData.comSubject;
        
        // 2. Initialisation du Sélecteur Client
        if (storedClient) {
            // Si la valeur stockée fait partie des options standard
            if (this.standardClientOptions.includes(storedClient)) {
                this.selectedClient = storedClient;
                this.hasCustomClientLabel = false;
                this.dbClientName = '';
                this.customClientName = '';
            } else {
                // Sinon, c'est une valeur personnalisée, on sélectionne "other"
                this.selectedClient = storedClient;
                this.dbClientName = storedClient;
                this.hasCustomClientLabel = true;
            }
        } else {
            // Valeur par défaut si rien n'est trouvé (au cas où l'API login n'aurait rien retourné)
            this.selectedClient = 'dossier'; // Le défaut que vous avez défini en Symfony
        }

        // 3. Initialisation du Sélecteur service (même logique)
        if (storedMission) {
          console.log("aaaa "+storedMission)
            if (this.standardMissionOptions.includes(storedMission)) {
                console.log("includes "+storedMission)
                this.selectedMission = storedMission;
                this.customMissionName = '';
                this.dbMissionName = '';
                this.hasCustomMissionLabel = false;
            } else {
                console.log("not includes "+storedMission)
                this.selectedMission = storedMission;
                this.dbMissionName = storedMission;
                this.hasCustomMissionLabel = true;
            }
        } else {
             // Valeur par défaut pour service (à adapter selon votre besoin réel)
            this.selectedMission = 'mission'; 
        }
  }
  

  sendTextSupport(){
    if (this.textSupport.trim() === '' || this.textSupport == null) {
      return;
    }
    this.authServices.sendMessageSupport(this.textSupport).subscribe(
        res => {
          this.textSupport = "";
          this.showMessage = true;
          setTimeout(() => {
            this.showMessage = false;
          }, 2000);
        },
        (error) => {
          alert('Erreur sendTextSupport ! : ' + error);
        }
      );
  }

  hideTooltipAdd() {
    console.log("outside")
    if(this.showtooltip){
      this.hideTooltip();
    } else if(this.showtooltiplang == 2){
      this.hideTooltipLang();
    }
  }

  getNameofCode(lang) {
    const language = this.languages.find(language => language.code === lang);
    return language ? language.name : 'Langue inconnue';
  }

  openSiteLanguage(){
    this.createproject = 8;
  }

  openDiscussLanguage(){
    this.createproject = 9;
  }

  quitLanguageSelect(){
    this.createproject = 7;
  }

  getMyInfo(){

    const userData = JSON.parse(localStorage.getItem('currentUser'));
    //console.log(' Avatar --> '+userData.imageUrl);
    this.img = (userData.imageUrl ? this.getAvatarlUrl(userData.imageUrl) : '../../../../assets/img/default-avatar.png');
    this.authServices.photoHeader.emit(userData.imageUrl);
    this.fname = userData.givenName;
    this.lname = userData.familyName;
    if (userData.birthDate) {
      if (userData.birthDate.date) 
      {
        this.dob = userData.birthDate.date;
      }
      else
      {
        this.dob = userData.birthDate;
        const raw = new Date(userData.birthDate);
        // Convertir vers yyyy-MM-dd
        this.datebirth = raw.toISOString().split('T')[0];
      }
    }
    this.jobT = userData.jobTitle;
    this.email = userData.email;
    this.gender = userData.gender;
    this.description = userData.description;
    this.phone = userData.telephone;
    //console.log("joot "+this.jobT)
    

      //console.log('getCurrentUser this.gender  id ==> ',this.gender );
      
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    //return "rrr";
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point
    return initials;
  }

  fctCancel(){
    this.edit = false;
    this.getMyInfo();
  }

  saveProfile() {
     
    let latest_date = null;

    if (this.datebirth) {
      latest_date = this.datepipe.transform(this.datebirth, 'dd-MM-yyyy');
    }

    // console.log('getCurrentUser paramètre id ==> '+this.idUser);
    this.authServices.udapteUser((this.fname ? this.fname : ''), (this.lname ? this.lname : ''), (latest_date ? latest_date : null), (this.jobT ? this.jobT : ''), (this.email ? this.email : '')
      ,(this.gender ? this.gender : ''), (this.description ? this.description : ''), (this.phone ? this.phone : ''), (this.oldPassword ? this.oldPassword : ''), (this.newPassword ? this.newPassword : '')).subscribe( data => {
       //console.log('retour saveProfile '+JSON.stringify(data));
       this.edit = false; 
       var currentUser = JSON.parse(localStorage.getItem('currentUser'));
        currentUser.givenName = data['givenName'];
        currentUser.familyName = data['familyName'];
        currentUser.jobTitle = data['jobTitle'];
        currentUser.gender = data['gender'];
        currentUser.birthDate = data['birthDate'];
        currentUser.telephone = data['telephone'];
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
        this.userData.givenName = data['givenName'];
        this.userData.familyName = data['familyName'];
       this.getMyInfo();
       alert('Modification(s) enregistré');
    }, (error) => {
      if(error.error) alert(error.error['hydra:description']);
        else alert('une erreur est survenue');
    });


    if(this.imageFil) {
      this.authServices.udapteUserImage(this.imageFil).subscribe( data => {
         //console.log('retour saveProfile '+JSON.stringify(data));
        this.getMyInfo();  
      }, (error) => {
          //console.log('Uh-oh, an error occurred! : ' +JSON.stringify(error));
          alert('une erreur est survenue');
      });
    
    }

  }

  getCurrentUser(){
    // console.log('getCurrentUser paramètre id ==> '+this.idUser);
     this.authServices.getInfoContact(this.idUser)
     .subscribe( dataContact => {
       this.contactInfo = dataContact;
       this.img = (this.contactInfo.imageUrl ? this.getAvatarlUrl(this.contactInfo.imageUrl) : '../../../../assets/img/default-avatar.png');
       this.fname =  this.contactInfo.givenName;
       this.lname =  this.contactInfo.familyName;
       if(this.contactInfo.birthDate) {
         if (this.contactInfo.birthDate.date) 
         {
           this.dob = this.contactInfo.birthDate.date;
         }
         else
         {
           this.dob = this.contactInfo.birthDate;
         }
       }
       //this.dob =  this.contactInfo.birthDate;
       this.jobT =  this.contactInfo.jobTitle;
       this.email =  this.contactInfo.email;
       this.gender =  this.contactInfo.gender;
       this.description =  this.contactInfo.description;
       this.phone =  this.contactInfo.telephone;
 
     }, (error) => {
         alert('une erreur est survenue');
     });
 
   }

  logout(viasocket = false) {
    if(viasocket == false){
      this.socketService.sendInstant({
        id: '',
        action: '0',
        type: "LOGOUTWEB",
        author: this.userData.id,
        recipient: this.userData.id,
        text: '',
        copy: "",
        private: false,
        res: "",
        project_lib: "",
        date: ""
    });
    }
    this.authServices.logout();
  }

  openProfile(){
    this.createproject = 3;
    this.getMyInfo();
  }

  openContacts(){
    this.createproject = 5;
  }

  openLanguage(){
    this.createproject = 7;
  }

  openNotif(){
    //this.createproject = 6;
    this.createproject = 12;
  }

  openEntreprise(){
    this.createproject = 20;
    //if(this.adminrole) this.router.navigate(['/entreppayment']);
  }

  openPersonnalisation(){
    this.createproject = 22;
    this.hasCustomClientLabel = false;
    this.hasCustomMissionLabel = false;
    this.loadUserPreferences();
  }

  selectOption(type: 'client' | 'mission', option: string): void {
        if (type === 'client') {
            this.selectedClient = option;
            if (option !== 'other') {
                this.customClientName = ''; // Réinitialiser l'input si ce n'est pas 'other'
            }
        } else if (type === 'mission') {
            this.selectedMission = option;
            console.log("missionn "+this.selectedMission)
            if (option !== 'other') {
                this.customMissionName = ''; // Réinitialiser l'input si ce n'est pas 'other'
            }
        }
    }

    // Méthode pour appliquer la personnalisation (à appeler lors du clic sur le bouton "Appliquer")
    applyCustomization(): void {
        // 1. Déterminer la valeur finale pour le Client
        let finalClientLabel: string;
        if (this.selectedClient === 'other' && (this.selectedClient.trim() === '' || this.selectedClient == null)) {
            alert('Veuillez tapez le nuveau nom du client dans autres')
        } else if (this.selectedClient === 'other') {
            finalClientLabel = this.customClientName;
        } else {
          finalClientLabel = this.selectedClient
        }

        // 2. Déterminer la valeur finale pour le sujet
        let finalMissionLabel: string;
        if (this.selectedMission === 'other' && (this.selectedMission.trim() === '' || this.selectedMission == null)) {
            alert('Veuillez tapez le nouveau nom du sujet dans autres')
        } else if (this.selectedMission === 'other') {
            finalMissionLabel = this.customMissionName;
        } else {
            finalMissionLabel = this.selectedMission;
        }

        console.log('Sujet final sélectionné:', finalClientLabel);
        console.log('Sujet final sélectionné:', finalMissionLabel);

        this.authServices.updateCompanyPreferences(finalClientLabel, finalMissionLabel).subscribe((response) => {
          this.userData = JSON.parse(localStorage.getItem('currentUser'));
          this.userData.comProject = finalClientLabel;
          this.userData.comSubject = finalMissionLabel;
          this.domainConfig.setConfig(finalClientLabel, finalMissionLabel);
          localStorage.setItem('currentUser', JSON.stringify(this.userData));
          alert('Vos données sont mis à jour 👍');
          this.quitCreateProject(null);
        });
    }

  openContactsUsers(){
    this.createproject = 21;
  }

  goToStatistiques(){
    this.authServices.currentProjectId.next(null);
    this.router.navigate(['/statistique']);
  }

  goToStorage(){
    this.authServices.currentProjectId.next(null);
    this.router.navigate(['/storage']);
  }

  refreshPage(): void {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([this.router.url]);
    });
  }

  private initIoConnection(id_project): void {
    this.socketService.subscribeToRoom(id_project);
  }
  
  setVar(){
    this.translate.get('guide.intro').subscribe(value => { 
      this.intro = value;
   });
   this.translate.get('guide.stepProject').subscribe(value => { 
     this.stepProject = value;
   });
   this.translate.get('guide.stepContact').subscribe(value => { 
     this.stepContact = value;
   });
   this.translate.get('guide.stepNotif').subscribe(value => { 
     this.stepNotif = value;
   });
   this.translate.get('guide.stepInvit').subscribe(value => { 
     this.stepInvit = value;
   });
   this.translate.get('guide.stepBoard').subscribe(value => { 
     this.stepBoard = value;
   });
   this.translate.get('guide.skipLabel').subscribe(value => { 
    this.skipLabel = value;
    });
    this.translate.get('guide.doneLabel').subscribe(value => { 
      this.doneLabel = value;
    });
    this.translate.get('guide.prevLabel').subscribe(value => { 
      this.prevLabel = value;
    });
    this.translate.get('guide.nextLabel').subscribe(value => { 
      this.nextLabel = value;
    });
  }

  changeSiteLangage(value =null){
    if(value) this.lang_site = value;
    this.authServices.udapteSiteLanguage(this.lang_site).subscribe( data => {
      this.translate.use(this.lang_site);
      this.messageService.setTranslate(this.lang_site);
      if(value) this.createproject = 7;
    }, (error) => {
    });
    
  }

  changeDiscussLangage(value =null){
    if(value) this.lang_discuss = value;
    this.authServices.udapteDiscussLanguage(this.lang_discuss).subscribe( data => {
      this.messageService.setTranslateDiscuss(this.lang_discuss);
      if(value) this.createproject = 7;
    }, (error) => {
        alert('une erreur est survenue lors de la traduction 1');
    });

    this.lang_discuss = value;
    this.messageService.setTranslateDiscuss(this.lang_discuss);
    this.createproject = 7;
  }

  autoTranslateEnable(value: boolean){
    this.autoTranslate = value;
    var stringvalue = ""+value;
    this.authServices.enableTranslateLanguage(value).subscribe( data => {
      this.messageService.setEnableTranslate(stringvalue);
    }, (error) => {
        //console.log('Uh-oh, an error occurred! : ' +JSON.stringify(error));
        alert('une erreur est survenue lors de la traduction 2');
    });
		
    /*
		this.authService.notifEnable(value,"APP_COPY_ENABLE").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
    */
	}


  setTheGuide(){
    setTimeout(() => {
      this.introJS.setOptions({
        skipLabel: this.skipLabel,
        doneLabel: this.doneLabel,
        prevLabel: this.prevLabel,
        nextLabel: this.nextLabel,
        steps: [
          { 
            intro: this.intro,
          },
          {
            element: '#stepProject',
            intro: this.stepProject,
            position: 'left'
          },
          {
            element: '#stepContact',
            intro: this.stepContact,
            position: 'bottom'
          },
          {
            element: '#stepNotif',
            intro: this.stepNotif,
            position: 'bottom'
          },
          {
            element: '#stepInvit',
            intro: this.stepInvit,
            position: 'bottom'
          },
          {
            element: '#stepBoard',
            intro: this.stepBoard,
            position: 'bottom'
          }
        ]
      });

      // if(!window.localStorage['guide']){
      //   this.introJS.start().oncomplete(function() {
      //       window.localStorage['guide'] = 1;
      //   });
      // }

    }, 2000);
  }

  trierProject(projectid){
    const index = this.projectLists.findIndex(item => item.id === projectid);
    if (index !== -1 && index !== 0) {
      const elementAaa = this.projectLists.splice(index, 1)[0];
      this.projectLists.unshift(elementAaa);
      this.messageService.setListProject(this.projectLists);
    }
    this.scrollToTop();
  }

  getSupp(date1, date2){
    if(date1>= date2){
      return date1;
    } else return date2;
  }

  getNotifSettings(){
    this.authServices.getNotificationSetting().subscribe(
		  res => {  
		  	//this.showLoadbar = false;
		    var setting = res['hydra:member'];
		    if (setting.length > 0) {
		    	for (var i = 0; i < setting.length; i++) {
		    		if(setting[i].propertyID == 'NOTIF_ALL_ENABLE'){
		    			this.NOTIF_ALL_ENABLE = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_EMAIL'){
		    			this.NOTIF_INV_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_PUSH'){
		    			this.NOTIF_INV_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_SON'){
		    			this.NOTIF_INV_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_EMAIL'){
		    			this.NOTIF_INSTANT_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_PUSH'){
		    			this.NOTIF_INSTANT_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_SON'){
		    			this.NOTIF_INSTANT_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_EMAIL'){
		    			this.NOTIF_STRUCT_REC_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_PUSH'){
		    			this.NOTIF_STRUCT_REC_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_SON'){
		    			this.NOTIF_STRUCT_REC_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_EMAIL'){
		    			this.NOTIF_STRUCT_COPY_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_PUSH'){
		    			this.NOTIF_STRUCT_COPY_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_SON'){
		    			this.NOTIF_STRUCT_COPY_SON = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_EMAIL'){
		    			this.NOTIF_STRUCT_COM_EMAIL = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_PUSH'){
		    			this.NOTIF_STRUCT_COM_PUSH = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_SON'){
		    			this.NOTIF_STRUCT_COM_SON = setting[i].value ? true : false;
		    		}	
		    	}
		    }
		    else
		    {
		    	this.NOTIF_ALL_ENABLE = true;
		    	this.NOTIF_INV_EMAIL = true;
		    	this.NOTIF_INV_PUSH = true;
		    	this.NOTIF_INV_SON = true;
		    	this.NOTIF_INSTANT_EMAIL = true;
		    	this.NOTIF_INSTANT_PUSH = true;
		    	this.NOTIF_INSTANT_SON = true;
		    	this.NOTIF_STRUCT_REC_EMAIL = true;
		    	this.NOTIF_STRUCT_REC_PUSH = true;
		    	this.NOTIF_STRUCT_REC_SON = true;
		    	this.NOTIF_STRUCT_COPY_EMAIL = true;
		    	this.NOTIF_STRUCT_COPY_PUSH = true;
		    	this.NOTIF_STRUCT_COPY_SON = true;
		    	this.NOTIF_STRUCT_COM_EMAIL = true;
		    	this.NOTIF_STRUCT_COM_PUSH = true;
		    	this.NOTIF_STRUCT_COM_SON = true;
		    }
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);
  }

  ngOnInit() {
    //console.log("dashnav init")
    this.activeStep = this.authServices.getGuideStep();
    this.isVisible = !this.authServices.isGuideClosed();
    this.routeAc.params.subscribe(paramsId => {
      this.currentProjectId = paramsId.ID;
      this.projectId = paramsId.ID;
      this.messageService.setProjectid(paramsId.ID)
    });
    this.authServices.selectStep$.subscribe(step => {
      this.selectStep(step);
    });
    this.authServices.projectshowed.subscribe((res: any) =>{ 
      this.createproject = null;
      this.authServices.changeStepProject.next("0");
    });
    this.authServices.projectselected.subscribe((res: any) =>{ 
      if(res) this.openDialogProjectNotif(null, res.id, res.libelle, res, false)
    });
    this.authServices.currentProjectId.subscribe((res: any) =>{ 
      this.currentProjectId = res;
      this.projectId = res;
      this.messageService.setProjectid(res);
    });
    this.searchControl.valueChanges.subscribe(searchText => {
      const removeAccents = (str: string): string => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      };
    
      const normalizedSearch = removeAccents(searchText.toLowerCase());
    
      this.filteredLanguages = this.languages.filter(language =>
        removeAccents(language.name.toLowerCase()).includes(normalizedSearch)
      );
    });
    this.searchControlSite.valueChanges.subscribe(searchText => {
      const removeAccents = (str: string): string => {
        return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      };
      const normalizedSearch = removeAccents(searchText.toLowerCase());
    
      this.filteredLanguagessite = this.languagessite.filter(language =>
        removeAccents(language.name.toLowerCase()).includes(normalizedSearch)
      );
    });
    this.lang_site= this.authServices.lang_site;
    this.changeSiteLangage();
    this.lang_discuss= this.authServices.lang_discuss;
    this.autoTranslate = this.authServices.lang_translate;
    this.setupSearchSubscription();
    this.new_message = false;
    this.new_message_instant = false;
    this.new_invitation = false;
    this.prob_cnx = false;
    this.new_coadmin = false;
    this.adminrole = this.userData.roles.includes('ROLE_MANAGER');
    /*this.authServices.getTotalNotAnswered().subscribe(res => {
          this.totalNotAnswered = res['hydra:totalItems'];
    });*/

    this.getNotifSettings();
    this.getStats();
    this.authServices.newMessageSubject.subscribe((object: any) =>{ 
      this.new_message = object;
    });

    this.authServices.newMessageInvSubject.subscribe((object: any) =>{ 
      this.new_invitation = object;
    });

    this.authServices.ban_typeSubject.subscribe((object: any) =>{ 
      this.ban_type = object;
    });

    this.authServices.ban_projSubject.subscribe((object: any) =>{ 
      this.ban_proj = object;
    });

    this.authServices.text_baniere_titleSubject.subscribe((object: any) =>{ 
      //console.log("before subject : "+object)
      this.text_baniere_title = object;
      //console.log("after subject : "+this.text_baniere_title)
    });

    this.authServices.text_baniere_type.subscribe((object: any) =>{ 
      this.text_baniere_type = object;
    });

    this.authServices.text_baniere_sujet.subscribe((object: any) =>{ 
      this.text_baniere_sujet = object;
    });

    this.authServices.text_baniere_format.subscribe((object: any) =>{ 
      this.text_baniere_format = object;
    });

    this.authServices.text_baniereSubject.subscribe((object: any) =>{ 
      this.text_baniere = object;
    });

    this.authServices.text_baniere_instantSubject.subscribe((object: any) =>{ 
      this.text_baniere_instant = object;
    });

    this.authServices.text_baniere_instant_body.subscribe((object: any) =>{ 
      this.text_baniere_instant_body = object;
    });

    this.authServices.text_baniere_body.subscribe((object: any) =>{ 
      this.text_baniere_body = object;
    });

    this.authServices.newMessageInstantSubject.subscribe((object: any) =>{ 
      this.new_message_instant = object;
    });

    this.authServices.newMessageInvSubject.subscribe((object: any) =>{ 
      this.new_invitation = object;
    });

    this.authServices.newCoadminSubject.subscribe((object: any) =>{ 
      this.new_coadmin = object;
    });

    this.authServices.initNotifInstant.subscribe((object: any) =>{ 
      //console.log("reçu from notif : "+object);
      //this.projectLists.filter(item => item.id == object)[0].userProject[0].number = 0;
      const project = this.projectLists.find(item => item.id === object);

      if (project && project.userProject && project.userProject.length > 0) {
        project.userProject[0].number = 0;
        console.log("calculate in initNotifInstant ")
        this.calculateTotalNotifications();
        this.cdr.detectChanges();
      } else {
        console.warn('Dossier ou userProject non trouvé');
      }
    });

    

    this.authServices.selectProject.subscribe((res) => {
      if(res == "select"){
        this.updclicked = !this.updclicked;
      } else if(res == "params"){
        this.createproject = 2;
      } else if(res == "langue"){
        this.createproject = 7;
      } else if(res == "entreprise"){
        this.createproject = 20;
      } else if(res == "invitation"){
        this.createproject = 30;
      } else if(res == "help"){
        this.openContacts();
      }
    });
    if(window.location.href.endsWith("/invitations")){
        this.createproject = 30;
    } 

    
    this.authServices.obinstantMsgsent.subscribe((object: any) =>{ 
      this.ifme = object.idmsg;
      
      this.projectLists.filter(item => item.id == object.id)[0].userProject[0].lasttext = object.text;
      this.projectLists.filter(item => item.id == object.id)[0].userProject[0].lastmsg = object.date;
      if(this.filterRead != 'structured') this.trierProject(object.id);
      this.calculateTotalNotifications();
      
        
    });

    this.authServices.obreceiveMsgsent.subscribe((object: any) =>{ 
      //this.projectLists.filter(item => item.id == idProject)[0].userProject[0].face += 1;
      this.updateProjectNotifications(object.id).subscribe((total) => {
        this.projectMapFace[object.id]=total;
        this.projectLists.filter(item => item.id == object.id)[0].userProject[0].lastface = object.date;
        this.projectLists.filter(item => item.id == object.id)[0].userProject[0].lasttext = object.text;
        this.projectLists.filter(item => item.id == object.id)[0].userProject[0].lastmsg = object.date;
        if(this.filterRead != 'instant') this.trierProject(object.id);
        this.calculateTotalNotifications();
        this.updateHeaderNotifs();
        //this.projectLists.filter(item => item.id == message.action)[0].userProject[0].face = total;
      });
    });

    this.authServices.obreceiveAsread.subscribe((idProject: any) =>{ 
      if(this.projectMapFace[idProject] > 0){
        this.projectMapFace[idProject]--;
        this.messageService.setProjectMapFace(this.projectMapFace);
      } 
    });

  this.authServices.obUpdateProfile.subscribe((res) => {
      if(res === '1'){
        this.getMyDatas();
      } 
  });

    

  this.authServices.obProjectDeleted.subscribe((project : any) =>{ 
    this.socketService.sendInstant({
        id: project.id,
        action: project.id,
        type: "DELPROJECT",
        author: this.userData.fullName,
        recipient: this.userData.id,
        text: '',
        copy: "",
        private: false,
        res: "",
        project_lib: project.libelle,
        date: ""
    });
  });

  this.checkUserRequestData();


  }

  selectStep(step: number): void {
    this.activeStep = step;
    const currentStep = this.authServices.getGuideStep();

    if (currentStep === step) {
      return;
    }

    // Mise à jour locale immédiate
    this.authServices.setGuideStep(step);

    // Récupérer l'utilisateur connecté
    const user = JSON.parse(
      localStorage.getItem('currentUser') || '{}'
    );

    if (!user.id) {
      return;
    }

    // Mise à jour en base
    this.authServices.updateUserStep(step).subscribe(
      () => {
        console.log('Étape enregistrée en base :', step);
      },
      error => {
        console.error('Erreur lors de la sauvegarde de step', error);
      }
    );
  }

  closeGuide(): void {
    this.isVisible = false;
    this.authServices.setGuideClosed(true);
  }

  openPackComponentDialog(type = 0, currentPack = 'free'){
    this.dialogRef = this.dialog.open(PackComponent, {
      panelClass: 'packclass',
      backdropClass: 'custom-backdrop-pack',
      height: "height: calc(-80px + 100vh);",
      disableClose: true,  // Empêche la fermeture avec ESC ou clic sur backdrop
      hasBackdrop: true,   // Assure qu'il y a un backdrop
      closeOnNavigation: false,
      data: { type: type, pack: currentPack}
    });

    this.dialogRef.afterClosed().subscribe(result => {
    });
  }

  updateHeaderNotifs(){
    this.authServices.obnotifupdated.next("1");
  }

  getMyDatas(){
    var iduser = JSON.parse(localStorage.getItem('currentUser')).id;
     this.authServices.getInfoContact(iduser)
     .subscribe( dataContact => {
        this.userData.imageUrl = dataContact['imageUrl'];
     }, (error) => {
         alert('une erreur est survenue getCurrentUser update profile image');
     });
 
   }

   getStats(){
    this.authServices.getGlobalStats().subscribe(  
    (success) => {
     
      var dataArray = success['hydra:member'];
      this.stat_projects = dataArray.totalProject;
      this.stat_documents = dataArray.totalFile;
      this.stat_exchanges = dataArray.totalMessage;
      this.stat_tasks = dataArray.totalTask;
    },
    (error) => {
      alert('Erreur global stats ! : ' + error)
    });
   }

  calculateDate(date) {
    var result = 0;
    var today = new Date().setHours(0, 0, 0, 0);
    var yesterday = new Date(new Date().setDate(new Date().getDate()-1)).setHours(0, 0, 0, 0);
    date = new Date(date);
    if (date >= today) {
      result = 1;
    } else if (date >= yesterday) {
      result = 2;
    } else result = 3;
    return result;
  }

  setProjectNotif(idproject){

  }

  showLanguage(){
    this.authServices.selectProject.emit("langue");
  }

  hideTooltip(){
    this.showtooltip = false;
    this.showtooltiplang = 2;
  }

  hideTooltipLang(){
    this.showtooltiplang = 0;
  }


  changeLang(){
    this.translate.use(this.lang);
    this.messageService.setTranslate(this.lang);
  }

  userIsAdmin(project){
    if (project.creator.id == this.currentUser) {
        return 'admin';
    }
    var member = project['userProject'];
    for (var i = 0; i < member.length; i++) {
      if(member[i].user && member[i].user.id == this.currentUser && member[i].isAdmin == true){
        return 'co-admin';
      }
    }
    return 'membre';
  }

  updateProjectNotifications(id) {
    var total = 0;
    const observables = [
      this.authServices.getAllProjectNotification(0, 1, 10, id)
    ]
    return forkJoin(observables).pipe(
      map((responses: any[]) => { // Définir le type explicite ici
        let total = 0;
        responses.forEach((res) => {
          total += res['hydra:member']['all'];
        });
        return total;
    }));

  }

  updateProjectNotificationsOld(id) {
    /*var sentNotifProjectCount = 0;
    var receiveNotifProjectCount = 0;
    var copyNotifProjectCount = 0;
    var commentNotifProjectCount = 0;*/
    var total = 0;
    const observables = [
      this.authServices.getOnlyProjectNotification(0, 1, 1000, id),

      this.authServices.getOnlyProjectNotification(1, 1, 1000, id),

      this.authServices.getOnlyProjectNotification(2, 1, 1000, id),

      this.authServices.getOnlyProjectNotification(3, 1, 1000, id),
    ]
    return forkJoin(observables).pipe(
      map((responses: any[]) => { // Définir le type explicite ici
        let total = 0;
        responses.forEach((res) => {
         // console.log("--json-- " + JSON.stringify(res));
          total += res['hydra:totalItems'];
        });
        return total;
      })
    );

  }

  isChromeBrowser() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return !userAgent.includes('chrome');
  }

  requestPermission(): Promise<NotificationPermission> {
    if (!("Notification" in window)) {
      console.error("This browser does not support desktop notification");
      return Promise.resolve('denied');
    } else {
      return Notification.requestPermission();
    }
  }

  showNotification() {
    if (document.visibilityState !== 'visible') {
      const iconUrl = "../../../../assets/img/face-switch.png";
  
      // Afficher la notification avec une icône de taille plus grande
      const notification = new Notification('Nouveau message', {
        body: 'Vous avez reçu un nouveau message sur votre application.',
        icon: iconUrl
      });
    }
  }

  showNotificationComment() {
    if (document.visibilityState !== 'visible') {
      const iconUrl = "../../../../assets/img/face-switch.png";
  
      // Afficher la notification avec une icône de taille plus grande
      const notification = new Notification('Nouveau message', {
        body: 'Vous avez reçu un nouveau commentaire sur votre application.',
        icon: iconUrl
      });
    }
  }

  showNotificationResponse() {
    if (document.visibilityState !== 'visible') {
      const iconUrl = "../../../../assets/img/face-switch.png";
  
      // Afficher la notification avec une icône de taille plus grande
      const notification = new Notification('Nouveau message', {
        body: 'Vous avez reçu une réponse sur votre application.',
        icon: iconUrl
      });
    }
  }

  stopTyping(idProject){
    this.projectLists.filter(item => item.id == idProject)[0].userProject[0].userTyping = null;
    this.typingDots = '';
    this.typingUser = null;
  }


  loadProject(url?: string){
    //console.log("init load : ");
    url = url ? url : undefined;
    //var progress = 0;
    //this.socketService.initSocket();
    this.socketService.unsubscribeFromRoom("0");
    this.initIoConnection(0);
    this.messageService.setListProject([]);
    this.projectLists = [];
    this.projectsIds = [];
    this.loadPartProjects();
    this.authServices.getProjectsIds().subscribe(res => {
      var lengthresults = res['hydra:totalItems'] ;
      var resultat = res['hydra:member'];
      this.total_project = lengthresults;
      this.actif_project = resultat.filter(item => item.isArchived == false).length;
      this.archived_project = resultat.filter(item => item.isArchived == true).length;
      console.log("total all : "+this.total_project)
      console.log("total actif : "+this.actif_project)
      console.log("total aarchived : "+this.archived_project)
      this.messageService.setTotalProject(this.total_project);
      this.init_total_project = lengthresults;
      if(this.filterRead == 'all') this.total_project = this.init_total_project;
      this.projectsIds = res['hydra:member'];
      this.projectsIds.map((value, index) => {
        this.initIoConnection(value.id);
      });
      if (this.ioConnection) {
        
      } else {
        this.socket_service_onMessage = this.ioConnection = this.socketService.onMessage()
        .subscribe((message: Message) => {
          this.projectState.inProject$.subscribe(inProject => {
            this.inProject = inProject;
          });

          this.projectState.isInstantMode$.subscribe(isInstant => {
            this.inFace = !isInstant;  // ou selon ta logique
          });
          console.log("inproject: "+this.inProject)
          console.log("inFace: "+this.inFace)
          /*
          const projectbtn = document.getElementById('typeprojectin') as HTMLButtonElement;
          const instantbtn = document.getElementById('checkinstantyes') ;
          if (projectbtn) {
            this.inProject = true
            if (instantbtn) {
              this.inFace = false;
            } else {
              this.inFace = true;
            }
          } else {
            this.inProject = false;
          }*/
        console.log("socket "+JSON.stringify(message))
          var project = this.projectLists.filter(item => item.id == message.action)[0];
          if(!project && ((message.type == "INSTANT") || 
              (message.type == "FACE" && (message.copy.includes(this.currentUser) || (message.recipient == this.currentUser) || (message.author == this.currentUser))) ||
              (message.type == "COMMENT" && message.author !== this.currentUser) ||
              (message.type == "RESPONSE" && message.author !== this.currentUser && (message.copy.includes(this.currentUser) || (message.recipient == this.currentUser)))
              )){
                  this.authServices.getTheProject(message.action)
                  .subscribe(response => {
                  this.initIoConnection(message.action);
                  this.projectLists.unshift(response);
                  this.playSound();
                  const bgColor = this.getRandomColor();
                  this.projectLists[0].randomColor = bgColor;
                  this.projectLists[0].textColor = this.darkenColor(this.projectLists[0].color);
                  this.perPage += 1; 
                  this.projectLists[0].userProject.filter(userProject => {
                    return userProject.user && userProject.user.id === this.currentUser;
                  });
                  this.updateProjectNotifications(message.action).subscribe((total) => {
                    //this.total_notif = (this.total_notif - this.projectMapFace[message.action] + total)
                    this.projectMapFace[message.action]=total;
                  });
                  this.updateHeaderNotifs();
                  this.projectLists = this.projectLists.sort(function (a, b) {
                    if (a.userProject[0].lastmsg > b.userProject[0].lastmsg) { return -1; }
                    if (a.userProject[0].lastmsg < b.userProject[0].lastmsg) { return 1; }
                    return 0;
                  })
                  this.projectLists.forEach(project => {
                    const bgColor = this.getRandomColor();
                    project.randomColor = bgColor;
                    project.textColor = this.darkenColor(project.color);
                  });
                  this.messageService.setListProject(this.projectLists);
                });
          } else if (message.type == "READMSG" && message.author === this.currentUser && ((this.messageService.getProjectid() !== message.action) || this.inProject == false || (this.inProject == true && this.inFace == true))/* || this.newProjectId == undefined)*/) {
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].number = 0;
            this.calculateTotalNotifications();
            this.messageService.setListProject(this.projectLists);
          } else if (message.type == "INSTANT" /*&& this.ifme != message.id*/ && ((this.messageService.getProjectid() !== message.action) || this.inProject == false || (this.inProject == true && this.inFace == true))/* || this.newProjectId == undefined)*/) {
            console.log("obreceiveMessage dashnav 0")
            if(message.author !== this.currentUser) this.projectLists.filter(item => item.id == message.action)[0].userProject[0].number += 1;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastinstant = message.date;
            this.stopTyping(message.action);
            if(this.filterRead != 'structured') this.trierProject(message.action);
            this.calculateTotalNotifications();
            this.new_message = false;
            this.new_invitation = false;
            this.new_coadmin = false;
            if(message.author !== this.currentUser && this.notifActivated(message.action)) {
              this.authServices.newMessageSubject.next(false);
              this.authServices.ban_typeSubject.next("instant");
              this.authServices.ban_projSubject.next(message.action);
              this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
              this.authServices.text_baniere_instantSubject.next(message.project_lib);
              this.authServices.text_baniere_type.next("INSTANTANEE");
              this.authServices.text_baniere_instant_body.next((message.res["text"] ? message.res["text"] : "document"));
              this.authServices.text_baniere_format.next("Message");
              this.authServices.newMessageInstantSubject.next(true);
              if(message.author !== this.currentUser) this.playSound();
            }
            /*
            if((this.inProject == true && this.inFace == true && (this.messageService.getProjectid() === message.action))) {
              this.authServices.obreceiveBaniere.next("instant");
            }*/
            this.messageService.setListProject(this.projectLists);
          } else if(message.type == "INSTANT" && this.ongletId != message.recipient /*&& message.author !== this.currentUser*/ && this.messageService.getProjectid() === message.action){
            console.log("obreceiveMessage dashnav 1")
            this.authServices.obreceiveMessage.next(message.res);
            this.stopTyping(message.action);
            this.ifme = null;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
            if(this.filterRead != 'structured') this.trierProject(message.action);
            this.calculateTotalNotifications();
            if(message.author !== this.currentUser) {
              if(this.notifActivated(message.action)){
                this.playSound();
                this.new_message = false;
                this.new_invitation = false;
                this.new_coadmin = false;
                this.authServices.newMessageSubject.next(false);
                this.authServices.ban_typeSubject.next("instant");
                this.authServices.ban_projSubject.next(message.action);
                this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
                this.authServices.text_baniere_instantSubject.next(message.project_lib);
                this.authServices.text_baniere_type.next("INSTANTANEE");
                this.authServices.text_baniere_instant_body.next((message.res["text"] ? message.res["text"] : "document"));
                this.authServices.text_baniere_format.next("Message");
                this.authServices.newMessageInstantSubject.next(true);
              }

              this.socketService.sendInstant({
                id: '',
                action: message.action,
                type: "READMSG",
                author: this.currentUser,
                author_name: '',
                recipient: '',
                text: '',
                copy: "",
                private: false,
                res: '',
                project_lib: '',
                date: ''
              });
            }
          } else if(message.type == "FACE" /*&& message.author !== this.currentUser*/ && (message.copy.includes(this.currentUser) || (message.recipient == this.currentUser) || (message.author == this.currentUser))){
            if((this.messageService.getProjectid() === message.action) && (this.inProject == true && this.inFace == true)){
              this.authServices.obreceiveFace.next(message.res);
            } 
            if((message.author == this.currentUser || message.recipient == this.currentUser) && this.filterRead == "structured") {
              this.filterProjects("structured");
            }
            if(message.author !== this.currentUser && this.notifActivated(message.action)) {
              this.playSound();
              this.authServices.newMessageSubject.next(true);
              this.authServices.ban_typeSubject.next("face");
              this.authServices.ban_projSubject.next(message.action);
              this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
              this.authServices.text_baniereSubject.next(message.project_lib);
              this.authServices.text_baniere_sujet.next(message.res["tags"][0].libelle);
              this.authServices.text_baniere_type.next("ORGANISEE");
              this.authServices.text_baniere_body.next((message.res["text"] ? message.res["text"] : "document"));
              this.authServices.text_baniere_format.next("Message");
              this.authServices.newMessageInstantSubject.next(false);
            } else this.updateHeaderNotifs();
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastface = message.date;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
            if(this.filterRead != 'instant') this.trierProject(message.action);
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
              this.calculateTotalNotifications();
            });
            this.updateHeaderNotifs();
          } else if(message.type == "DISABLE" && message.author !== this.currentUser && (message.copy.includes(this.currentUser) || (message.recipient == this.currentUser))){
            if((this.messageService.getProjectid() === message.action) && (this.inProject == true && this.inFace == true)){
              this.authServices.obreceiveResponse.next(message.id);
            }
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
            });
            this.updateHeaderNotifs();
          } else if(message.type == "DISABLE" && message.author !== this.currentUser && (message.private == false) ){
            if((this.messageService.getProjectid() === message.action) && (this.inProject == true && this.inFace == true)){
              this.authServices.obreceiveResponse.next(message.id);
            }
          } else if(message.type == "MARKADMIN" && message.res == this.currentUser && (this.messageService.getProjectid() == message.action)){
            this.authServices.obreceiveAdmin.next("1");
            if(this.notifActivated(message.action)){
              this.new_message = false;
              this.new_message_instant = false;
              this.new_invitation = false;
              this.new_coadmin = true;
              this.authServices.newCoadminSubject.next(true);
              this.authServices.text_baniere_titleSubject.next(message.recipient);
              this.authServices.ban_typeSubject.next("vous a marqué comme Co-Admin dans ce dossier");
            }
          } else if(message.type == "DELETEADMIN" && message.res == this.currentUser && (this.messageService.getProjectid() == message.action)){
            if(this.notifActivated(message.action)){
              this.authServices.obDeletedmin.next("1");
              this.new_message = false;
              this.new_message_instant = false;
              this.new_invitation = false;
              this.new_coadmin = true;
              this.authServices.newCoadminSubject.next(true);
              this.authServices.text_baniere_titleSubject.next(message.recipient);
              this.authServices.ban_typeSubject.next("vous a enlevé le droit Co-Admin dans ce dossier");
            }
          } else if(message.type == "MARKREADRESPONSE"  && message.author == this.currentUser){
            //console.log("MARQUER LU SOCKET RESPONSE");
            if(this.inProject == true && this.inFace == true && (this.messageService.getProjectid() === message.action)){
              //console.log("DANS ORGANISE");
              this.authServices.obResponseLu.next(message.id);
            }
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
            })
            this.updateHeaderNotifs();
          } else if(message.type == "MARKREADQUESTION" && (this.messageService.getProjectid() === message.action)  && message.author == this.currentUser && this.ongletId != message.recipient ){
            if(this.inProject == true && this.inFace == true){
              this.authServices.obQuestionLu.next(message.id);
            }
          } else if(message.type == "MARKREADCPYRESPONSE"  && message.author == this.currentUser){
            if(this.inProject == true && this.inFace == true && (this.messageService.getProjectid() === message.action) && this.ongletId != message.recipient){
              this.authServices.obResponseCpyLu.next(message.id);
            }
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
            })
            this.updateHeaderNotifs();
          } else if(message.type == "MARKREADCPYQUESTION" && message.author == this.currentUser){
            if(this.inProject == true && this.inFace == true && (this.messageService.getProjectid() === message.action) && this.ongletId != message.recipient){
              this.authServices.obQuestionCpyLu.next(message.id);
            }
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
            })
            this.updateHeaderNotifs();
          } else if(message.type == "MARKREADCOMMENT" && message.author == this.currentUser){
            if(this.inProject == true && this.inFace == true && (this.messageService.getProjectid() === message.action)  && this.ongletId != message.recipient){
              this.authServices.obCommentLu.next(message);
            }
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
            })
            this.updateHeaderNotifs();
          } else if((message.type == "ADDSUBJECT") && (this.messageService.getProjectid() === message.action) && (this.ongletId != message.recipient) && (this.inProject == true && this.inFace == true)){
            this.authServices.obSubAdd.next(message.res);
          } else if((message.type == "RENAMESUBJECT") && (this.messageService.getProjectid() === message.action) && (this.ongletId != message.recipient) && (this.inProject == true && this.inFace == true)){
            this.authServices.obSubRename.next(message.res);
          } else if((message.type == "RENAMEPROJECT") && (this.ongletId != message.recipient)){
            if(this.messageService.getProjectid() === message.action) this.messageService.setLibelleProject(message.res);
            this.projectLists.forEach((value,index)=>{
              if(value.id==message.action) {
                this.projectLists[index].libelle = message.res;
              }
            });
          } else if (message.type == "COMMENT" && message.author !== this.currentUser && ((this.messageService.getProjectid() !== message.action) || this.inProject == false || (this.inProject == true && this.inFace == false))/* || this.newProjectId == undefined)*/) {
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
              this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
              this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
              this.ban_msg = message.res.number;
              if(this.notifActivated(message.action)){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("comment");
                this.authServices.ban_projSubject.next(message.action);
                this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
                this.authServices.text_baniereSubject.next(message.project_lib);
                this.authServices.text_baniere_sujet.next(message.res["tags"][0].libelle);
                this.authServices.text_baniere_type.next("ORGANISEE");
                this.authServices.text_baniere_body.next((message.res["text"] ? message.res["text"] : "document"));
                this.authServices.text_baniere_format.next("Commentaire");
                this.playSound();
              }
              //this.showNotificationComment();
              this.authServices.newMessageInstantSubject.next(false);
              if(this.filterRead != 'instant') this.trierProject(message.action);
              this.calculateTotalNotifications();
            });
            this.updateHeaderNotifs();
          } else if(message.type == "COMMENT" && message.author !== this.currentUser && this.messageService.getProjectid() === message.action){
            this.authServices.obreceiveComment.next(message.id);
            
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
              this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
              this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
              if(this.notifActivated(message.action)){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("comment");
                this.authServices.ban_projSubject.next(message.action);
                this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
                this.authServices.text_baniereSubject.next(message.project_lib);
                this.authServices.text_baniere_sujet.next(message.res["tags"][0].libelle);
                this.authServices.text_baniere_type.next("ORGANISEE");
                this.authServices.text_baniere_body.next((message.res["text"] ? message.res["text"] : "document"));
                this.authServices.text_baniere_format.next("Commentaire");
                this.playSound();
              }
              //this.showNotificationComment();
              this.authServices.newMessageInstantSubject.next(false);
              if(this.filterRead != 'instant') this.trierProject(message.action);
              this.calculateTotalNotifications();
            });
            this.updateHeaderNotifs();
          } else if(message.type == "RESPONSE" && message.author !== this.currentUser && (message.copy.includes(this.currentUser) || (message.recipient == this.currentUser))){
            if((this.messageService.getProjectid() === message.action) && (this.inProject == true && this.inFace == true)){
              this.authServices.obreceiveResponse.next(message.id);
            }
            //this.showNotificationResponse();
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastface = message.date;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
            this.updateProjectNotifications(message.action).subscribe((total) => {
              this.projectMapFace[message.action]=total;
              this.calculateTotalNotifications();
            })
            this.updateHeaderNotifs();
            if(this.notifActivated(message.action)){
              this.playSound();
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("face");
                this.authServices.ban_projSubject.next(message.action);
                this.authServices.text_baniere_titleSubject.next(message.res["author"].fullName);
                this.authServices.text_baniereSubject.next(message.project_lib);
                this.authServices.text_baniere_type.next("ORGANISEE");
                this.authServices.text_baniere_sujet.next(message.res["tags"][0].libelle);
                this.authServices.text_baniere_body.next((message.res["text"] ? message.res["text"] : "document"));
                this.authServices.text_baniere_format.next("Réponse");
                this.authServices.newMessageInstantSubject.next(false);
            }
            if(this.filterRead != 'instant') this.trierProject(message.action);
            this.authServices.obreceiveResponse.next(message.id);
            
          } else if(message.type == "RESPONSE" && message.author == this.currentUser && this.ongletId != message.ongletid){
            if((this.messageService.getProjectid() === message.action) && (this.inProject == true && this.inFace == true)){
              this.authServices.obreceiveResponse.next(message.id);
            }
            //this.playSound();
            //this.showNotificationResponse();
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastface = message.date;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lasttext = message.text;
            this.projectLists.filter(item => item.id == message.action)[0].userProject[0].lastmsg = message.date;
            this.updateProjectNotifications(message.action).subscribe((total) => {
                this.projectMapFace[message.action]=total;
                this.calculateTotalNotifications();
            })
            this.updateHeaderNotifs();
            if(this.filterRead != 'instant') this.trierProject(message.action);
            //this.authServices.obreceiveResponse.next(message.id);
            
          } else if(message.type == "PROJECTINVITATION" && message.author == this.currentUser){
            this.authServices.obreceiveInvitation.next(message.recipient);
          } else if(message.type == "INVITATION" && message.author !== this.currentUser && message.text === this.currentUser){
            this.authServices.obInviteInstant.next(1);
              this.authServices.newMessageInvSubject.next(true);
              this.authServices.ban_typeSubject.next("invitation");
              this.authServices.ban_projSubject.next(null);
              this.authServices.text_baniere_titleSubject.next(message.recipient);
              this.authServices.text_baniereSubject.next(message.project_lib);
              this.authServices.text_baniere_type.next("Invitation");
              this.authServices.text_baniere_body.next("Invitation");
              this.authServices.text_baniere_format.next("Invitation");
              this.authServices.newMessageInstantSubject.next(false);
            this.playSound();
          } else if(message.type == "INVITATIONPROJ" && message.author !== this.currentUser && (message.copy.includes(this.currentUser))){
            //console.log("invitations "+JSON.stringify(message));
            this.authServices.obInviteInstant.next(1);
              this.authServices.newMessageInvSubject.next(true);
              this.authServices.ban_typeSubject.next("invitation");
              this.authServices.text_baniere_type.next("invitation");
              this.authServices.ban_projSubject.next(null);
              this.authServices.text_baniere_titleSubject.next(message.recipient);
              this.authServices.text_baniereSubject.next(message.project_lib);
              this.authServices.text_baniere_body.next("Invitation");
              this.authServices.text_baniere_format.next("Invitation");
              this.authServices.newMessageInstantSubject.next(false);
            this.playSound();
          } else if(message.type == "EXPORTREQUEST" && message.recipient == this.currentUser){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("user_data");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Votre fichier de données est prêt à télécharger");
                this.authServices.newMessageInstantSubject.next(false);
          } else if(message.type == "DELPROJECT"){
            const index = this.projectLists.findIndex(item => item.id === message.action);
            if (index !== -1) {
              const elementAaa = this.projectLists.splice(index, 1)[0];
              this.perPage -= 1;
              if(this.messageService.getProjectid() !== message.action){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("delproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le dossier a été supprimé");
                this.authServices.newMessageInstantSubject.next(false);
              }
            }
            if(this.messageService.getProjectid() == message.action){
              this.authServices.newMessageSubject.next(true);
              //alert("Le projet a été supprimée !!");this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("delproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le dossier a été supprimé");
                this.authServices.newMessageInstantSubject.next(false);
                setTimeout(() => {
              this.router.navigate(['/homes/wlc']);
                }, 2000);
            }
          } else if(message.type == "ARCHIVEPROJECT"){
            const index = this.projectLists.findIndex(item => item.id === message.action);
            if (index !== -1) {
              const elementAaa = this.projectLists.splice(index, 1)[0];
              this.perPage -= 1;
              if(this.messageService.getProjectid() !== message.action){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("archiveproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le document a été archivé");
                this.authServices.newMessageInstantSubject.next(false);
              }
            }
            if(this.messageService.getProjectid() == message.action){
              this.authServices.newMessageSubject.next(true);
              //alert("Le projet a été supprimé !!");this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("archiveproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le document a été archivé");
                this.authServices.newMessageInstantSubject.next(false);
                setTimeout(() => {
              this.router.navigate(['/homes/wlc']);
                }, 2000);
            }
          } else if(message.type == "UNARCHIVEPROJECT"){
            const index = this.projectLists.findIndex(item => item.id === message.action);
            if (index !== -1) {
              const elementAaa = this.projectLists.splice(index, 1)[0];
              this.perPage -= 1;
              if(this.messageService.getProjectid() !== message.action){
                this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("unarchiveproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le document a été désarchivé");
                this.authServices.newMessageInstantSubject.next(false);
              }
            }
            if(this.messageService.getProjectid() == message.action){
              this.authServices.newMessageSubject.next(true);
              //alert("Le projet a été supprimé !!");this.authServices.newMessageSubject.next(true);
                this.authServices.ban_typeSubject.next("unarchiveproject");
                this.authServices.ban_projSubject.next(null);
                //this.authServices.text_baniere_titleSubject.next(message.author);
                this.authServices.text_baniereSubject.next(null);
                this.authServices.text_baniere_titleSubject.next("Le document a été désarchivé");
                this.authServices.newMessageInstantSubject.next(false);
                setTimeout(() => {
              this.router.navigate(['/homes/wlc']);
                }, 2000);
            }
          } else if(message.type == "UPDATEPROFIL" && message.author === this.currentUser){
          console.log("image updated nav")
            this.authServices.obUpdateProfile.next('1');
          } else if(message.type == "UPDATECOMPANY" && message.res.id == this.userData.compId){
            this.authServices.obUpdateCompany.next(message);
          } else if(message.type == "UPDATECOMPNAME" && message.recipient == this.userData.compId){
            this.authServices.obUpdateCompname.next(message.res);
          } else if(message.type == "LOGOUTWEB" && message.author == this.currentUser){
            this.logout(true);
          } else if(message.type == "DELETEACCOUNT" && message.author == this.currentUser){
            this.logout(true);
          }
          
        })
        this.socketService.onUserTyping().subscribe((data) => {
          if(data.userId !== this.currentUser){
            //this.projectLists.filter(item => item.id == data.room)[0].userProject[0].userTyping = data;
            const project = this.projectLists.find(item => item.id == data.room);
            if (project) {
              project.userProject[0].userTyping = data;
            }
            this.typingUser = data.userId;
            this.startTypingDotsAnimation();
            if (this.typingTimeout) {
              clearTimeout(this.typingTimeout);
            }

            // Lance un nouveau timeout de 3 secondes
            this.typingTimeout = setTimeout(() => {
              if (project) {
                project.userProject[0].userTyping = null;
              }
              this.typingUser = null;
              this.typingDots = '';
            }, 3000); 
          }
          //this.typingUser = data;
        });
    
        // Écouter quand un autre utilisateur arrête de taper
        this.socketService.onUserStopTyping().subscribe((data) => {
          if(data.userId !== this.currentUser){
            this.projectLists.filter(item => item.id == data.room)[0].userProject[0].userTyping = null;
            this.typingDots = '';
            this.typingUser = null;
          }
          //this.typingUser = null;
        });
      }
      /*
      this.total_project = res['hydra:totalItems'];
      if(res['hydra:view']['hydra:next']){
        //this.loadProject(res['hydra:view']['hydra:next'].replace("/api", ""));
      }
      else if(res['hydra:totalItems'] == this.projectLists.length){
        this.messageService.setListProject(this.projectLists);
        this.messageService.setProjectMap(this.projectMap);
        this.loadNotifProjet();
      }*/
      this.messageService.setProjectMapFace(this.projectMapFace);
    }); 
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
  }

  downloadData(before){
    this.authServices.getUserDataZip(before).subscribe(res => {
        this.requestDataSent = true;
        alert("vous serez notifiés dès que vos données soient prêtes à télécharger");
      });
  }

  private startTypingDotsAnimation(): void {
    let dotCount = 0;
    const typingInterval = setInterval(() => {
      if (this.typingUser) {
        if (dotCount === 3) {
          dotCount = 0;
        }
        this.typingDots = '.'.repeat(dotCount + 1);
        dotCount++;
      } else {
        clearInterval(typingInterval);
      }
    }, 500);  // Change la vitesse des points (500ms)
  }

  redirectBaniere(){
    var path = null;
    this.new_message = false;
    this.new_message_instant = false;
    this.new_invitation = false;
    this.new_coadmin = false;
    if(this.ban_type == "instant"){
      this.authServices.initNotifInstant.next(this.ban_proj);
      if(this.ban_proj == this.messageService.getProjectid() && this.inFace == true){
        this.authServices.obchangeinterface.next(1);
        return;
      } else {
        path = '/project/'+this.ban_proj+'/openmsg';
      }
    } else if(this.ban_type == "face"){
      path = '/project/details/'+this.ban_proj+'/'+this.ban_msg+'/QUESTION';
    } else if(this.ban_type == "comment"){
      path = '/project/details/'+this.ban_proj+'/'+this.ban_msg+'/COMMENT';
    } else if(this.ban_type == "invitation"){
      this.authServices.obInviteClic.next("1");
      return;
    } else if(this.ban_type == "user_data"){
      this.checkUserRequestData(true);
      return;
    } else {
      return;
    } 
    if(path){
      this.router.navigate([path]);
    }
  }

  downloadDataFile() {
    const link = document.createElement('a');
    link.href = this.requestDataPath;
    link.download = '';
    link.click();
  }

  closeCnx(){
    this.prob_cnx = false;
    this.interceptor.setConnexionAlert(false);
  }

  closeScreen(){
    this.new_message = false;
    this.new_message_instant = false;
    this.new_invitation = false;
    this.new_coadmin = false;
  }

  closeScreenInstant(){
    this.new_message_instant = false;
    this.new_message = false;
    this.new_invitation = false;
    this.new_coadmin = false;
  }

  closeInvitations(){
    this.new_message_instant = false;
    this.new_message = false;
    this.new_invitation = false;
    this.new_coadmin = false;
  }

  calculateTotalNotifications() {
    if(this.filterRead == 'instant') {
    console.log("from calculateTotalNotifications instant")
      this.calculateInstantNotifications();
    } else if(this.filterRead == 'structured') {
    console.log("from calculateTotalNotifications structured")
      this.calculateStructNotifications();
    } else {
    console.log("from calculateTotalNotifications else")
      this.authServices.getCountNotif('all').subscribe(res => {
        this.total_notif = Number(res);
    });
    console.log("from calculateTotalNotifications countnotif à la fil")
    this.countNotif();
    }
  }

  calculateTotalInstNotif() {
    console.log("from calculateTotalInstNotif")
      this.calculateInstantNotifications();
      this.authServices.getCountNotif('all').subscribe(res => {
        this.total_notif = Number(res);
      });
  }

  calculateInstantNotifications() {
    console.log("from calculateInstantNotifications")
    this.authServices.getCountNotif('fil').subscribe(res => {
        this.total_notif_instant = Number(res);
    });
    /*
    this.total_notif_instant = this.projectLists.reduce((acc, project) => {
      // Vérifier et récupérer les notifications instantanées
      let notificationsInstantanees = ((project.userProject[0]) ? (project.userProject[0].number) : 0);

      // Retourner l'accumulateur avec la somme des notifications
      return acc + notificationsInstantanees;
    }, 0);  // 0 est la valeur initiale de l'accumulateur
    */
  }

  calculateStructNotifications() {
    console.log("from calculateStructNotifications")
    this.authServices.getCountNotif('bloc').subscribe(res => {
        this.total_notif_struct = Number(res);
    });
  }

  goToDashboard(){
      this.authServices.currentProjectId.next(null);
      //this.router.navigate(['/dashboard/notified']);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/dashboard', 'notified']);
      });
  }

  closeCoadmin(){
    this.new_message_instant = false;
    this.new_message = false;
    this.new_invitation = false;
    this.new_coadmin = false;
  }

  openGuide() {
    window.open('https://facecollectivite.com/securite/', ' ');
  }

  openConditions() {
    window.location.href = 'https://facecollectivite.com/cgu';
  }

  playSound(): void {
    var sound = this.messageService.getSound();
    if(sound){
      const audioPlayer = document.getElementById('audioPlayer') as HTMLAudioElement;
      audioPlayer.play();
    }
  }

  Total(a, b){
    return Number(a) + Number(b);
  }


  countNotif(){
    console.log("from countNotif 1")
    this.authServices.getCountNotif('fil').subscribe(res => {
        this.total_notif_instant = Number(res);
    });
    console.log("from countNotif 2")
    this.authServices.getCountNotif('bloc').subscribe(res => {
        this.total_notif_struct = Number(res);
    });
  }

  filterProjects(val){// to do heeeeere
    if (val == "all") {
      this.filterRead = "all";
      this.total_project = this.init_total_project;
      this.loadPartProjects(true);
    } else if(val == "instant"){
      this.filterRead = "instant";
      this.authServices.getProjectsInstantNotified().subscribe(res => {
        var result = res['hydra:member'];
        this.total_project = result.length;
        result.map((value, index) => {
          const bgColor = this.getRandomColor();
          value.randomColor = bgColor;
          value.textColor = this.darkenColor(value.color);
          value.userProject = value.userProject.filter(userProject => {
              return userProject.user && userProject.user.id === this.currentUser;
          });
        })
        this.projectLists = result;
        this.calculateTotalNotifications();
        this.messageService.setListProject(this.projectLists);
      });
    } else if (val == "structured") {
      this.filterRead = "structured";
      this.authServices.getProjectsStructuredNotified().subscribe(res => {
        var result = res['hydra:member'];
        this.total_project = result.length;
        result.map((value, index) => {
          const bgColor = this.getRandomColor();
          value.randomColor = bgColor;
          value.textColor = this.darkenColor(value.color);
          value.userProject = value.userProject.filter(userProject => {
              return userProject.user && userProject.user.id === this.currentUser;
          });
          this.projectMapFace[value.id]=value.userProject[0].face;
        })
        result = result.sort(function (a, b) {
          if (a.userProject[0].lastface > b.userProject[0].lastface) { return -1; }
          if (a.userProject[0].lastface < b.userProject[0].lastface) { return 1; }
          return 0;
        })
        this.projectLists = result;
        this.calculateTotalNotifications();
        this.messageService.setListProject(this.projectLists);
      });
    } else if (val == "private") {
      this.filterRead = "private";/*
      this.authServices.getProjectsPrivate().subscribe(res => {
        var result = res['hydra:member'];
        result.map((value, index) => {
          value.userProject = value.userProject.filter(userProject => {
              return userProject.user && userProject.user.id === this.currentUser;
          });
        })
        this.projectLists = result;
      });*/
    }
    this.messageService.setFilterNav(this.filterRead);
  }

   clearSearch() {
    this.searchProject = ''; // Vide le champ de recherche
  }

  setupSearchSubscription() {
    this.searchTerms.pipe(
      debounceTime(50), // Adjust the debounce time as needed
      switchMap(() => this.searchProjects())
    ).subscribe(results => {
      this.displayedProjects = [];
      this.displayedProjects = results['hydra:member'];
      this.displayedProjects.map((value, index) => {
          value.userProject = value.userProject.filter(userProject => {
            return userProject.user && userProject.user.id === this.currentUser;
          });
          this.projectMapFace[value.id]=value.userProject[0].face;
      });
    });
  }

  /*onSearch() {
    if (this.searchProject.trim() === '' || this.searchProject == null) {
      this.searchProject = null;
      return;
    }
    var shownprojects = [...this.projectLists];
    this.displayedProjects = this.filterLocalProjects(shownprojects, this.searchProject);
    
    this.authServices.searchProjects(this.searchProject).subscribe(serverResults => {
      this.displayedProjects = [];
      this.displayedProjects = this.mergeResults(this.displayedProjects, serverResults['hydra:member']);
      //this.displayedProjects = serverResults['hydra:member'];
    });
  }*/

  onScrollsearch(event: any): void { // TO DO 
    const container = this.scrollMeprojsearch.nativeElement;
    const atTop = container.scrollTop > (container.scrollHeight - (container.scrollHeight / 3));
    //if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
    if (atTop && this.canloadagainsearch && this.isdataloadedsearch == false) {
      this.isdataloadedsearch = true;
      this.scrollpositionsearch = container.scrollHeight;
      this.getSearchProjects();
    }
  }

  onSearch() {
    if (this.searchProject.trim() === '' || this.searchProject == null) {
      this.searchProject = null;
    } else this.searchTerms.next(this.searchProject);
  }

  checkUserRequestData(download = false) {
    this.authServices.checkUserRequestData().subscribe(
      (res) => {
        if(res['hydra:member'].length > 0) {
          this.requestDataSent = true;
          this.requestData = res['hydra:member'][0];
          if(this.requestData.status == 'ready'){
          this.requestDataPath = environment.server_url+"/media/user-export/"+this.requestData.originalName;
          if(download){
            this.downloadDataFile();
          }
          }
        } else this.requestDataSent = false;
      });
  }

  searchProjects() {
    this.pageSearch = 1;
    return this.authServices.searchProjects(this.searchProject).pipe(
      map(serverResults => {
        return serverResults;
      })
      //map(serverResults => this.mergeResults(this.displayedProjects, serverResults['hydra:member']))
    );
  }

  getSearchProjects() {
    this.pageSearch += 1;
    this.authServices.searchProjects(this.searchProject, this.pageSearch).subscribe((res)=>{
      this.displayedProjects = res['hydra:member']
      if(res['hydra:member'].length < 20){
        this.canloadagainsearch = false;
      }
      setTimeout(() => {
        this.restoreScrollPositionSearch();
      }, 0);
    });
  }

  restoreScrollPositionSearch() {
    const container = this.scrollMeprojsearch.nativeElement;
    container.scrollTop = this.scrollpositionsearch - 50;
    this.isdataloadedsearch = false;
  }

  filterLocalProjects(shownprojects, searchText: string): any[] {
    searchText = searchText.toLowerCase();
    return shownprojects.filter(it => it['libelle'].toLowerCase().includes(searchText));
  }

  mergeResults(localResults: any[], serverResults: any[]): any[] {
    const existingIds = new Set(localResults.map(item => item.id));
    const filteredServerResults = serverResults.filter(item => !existingIds.has(item.id));
    return [...localResults, ...filteredServerResults];
  }

  getRandomColor(): string {
      const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
      return this.vibrantColors[randomIndex];
  }

  darkenColor(bgColor: string) {
    if (!bgColor) return '#444';
    const key = bgColor.toLowerCase().substring(0, 7);
    return this.colorMap[key] || '#444'
  }

  fctprojectChosen(projectId, libelle, url, project = null){
    console.log("fctprojectChosen clicked");
    // always redirect vers face 
    //this.openDialogProjectNotif(null, projectId, libelle, project, false);
    //return;
    //end
    if(this.filterRead == 'structured' && project) {
      this.openDialogProjectNotif(null, projectId, libelle, project, false);
      return;
    }
    var url = null;
    if(!project.isPrivate){
      if(project.imageUrl) url = project.imageUrl;
    } else if(project.creator.id !== this.currentUser){
      if(project.creator.imageUrl) url = project.creator.imageUrl;
    } else if(project.creator.id === this.currentUser){
      if(project.privateuser && project.privateuser.imageUrl) url = project.privateuser.imageUrl;
    }
    if(this.messageService.getProjectid() == projectId && (this.inProject == true) && (this.inFace == true)){
      this.authServices.obchangeinterface.next(1);
    }
    //this.authServices.initHeader.emit("1");
    this.currentProjectId = projectId;
    this.projectId = projectId;
    this.messageService.setProjectid(projectId);
    this.projectChosen.emit(projectId);
    this.projectChanged.emit(libelle);
    if(url){
      this.imageChanged.emit(url);
    } else {
      this.imageChanged.emit(null);
    }
    this.projectState.isInstantMode$.subscribe(isInstant => {
        this.inFace = !isInstant;  // ou selon ta logique
        if(this.inFace) {
          this.authServices.scrollTop.next("1")
        }
    });
    if(this.projectLists.filter(item => item.id == projectId)[0]){
      const nbr_messages = this.projectLists.filter(item => item.id == projectId)[0].userProject[0].number;
      this.authServices.obreadMessage.next(nbr_messages);
      this.authServices.updateNotifications(nbr_messages);
      this.projectLists.filter(item => item.id == projectId)[0].userProject[0].number = 0;
    }
    this.router.navigate(['/project/'+projectId+'/openmsg']);
    
  }

  openDialogProjectNotif(event, idprojet, libelle, project, notified = true){
    var tab = { notifmode : true, id: idprojet, total: this.projectMapFace[idprojet]}
    if(this.projectMapFace[project.id] == 0) {
      tab = { notifmode : false, id: idprojet, total: 0}
      notified = false;
      /*this.fctprojectChosen(project.id, project.libelle, project.imageUrl, project);
      this.openDialogProjectNotif(null, project.id, libelle, project, false);
      return;*/
    }
    //const tab = { notifmode : true, id: idprojet}
    var url = null;
    if(!project.isPrivate){
      if(project.imageUrl) url = project.imageUrl;
    } else if(project.creator.id !== this.currentUser){
      if(project.creator.imageUrl) url = project.creator.imageUrl;
    } else if(project.creator.id === this.currentUser){
      if(project.privateuser && project.privateuser.imageUrl) url = project.privateuser.imageUrl;
    }
    this.authServices.obNotifiedMode.next(tab);
      this.currentProjectId = idprojet;
      this.projectId = idprojet;
      this.messageService.setProjectid(idprojet);
      this.notifChanged.emit(tab.total);
      this.projectChosen.emit(idprojet);
      this.projectChanged.emit(libelle);
      if(notified) {
        localStorage.setItem('notified', "notified");
        console.log("notiiiifed : "+notified);
      } else localStorage.setItem('notified', "all");
      if(url){
        this.imageChanged.emit(url);
      } else {
        this.imageChanged.emit(null);
      }
      this.dialog.closeAll();
      //this.router.navigate(['/project/'+idprojet]);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/project', idprojet]);
      });
  }

  

  openShareDialog() {
    const dialogRef = this.dialog.open(ShareDialogComponent, {
      panelClass: 'sharedialog-container'}
    );

    dialogRef.afterClosed().subscribe(result => {
    });
  }
  

  loadNotifProjet(){
    this.authServices.getNotification().subscribe(res => {
      this.notificationload = <any>res;
      for (var i = 0; i < this.projectLists.length; i++) {
        for (var index = 0; index < this.notificationload.length; index++) {
          if(this.notificationload[index].id == this.projectLists[i].id) {
            this.projectLists[i].notif = this.notificationload[index].total;
          }
        }
      }
    });
  }

  updDialog(): void{
    this.updclicked = !this.updclicked;
  }

  quitCreateProject(result: any): void{
    if (result == '1'){ 
      this.createproject = 11;
    } else if (result == '2'){ 
      this.openDialog();
    } else if (result == 'param'){ 
      this.createproject = 2;
    } else {
      this.authServices.changeStepProject.next("0");
      this.createproject = null;
    }
    this.edit = false;
  }

  onNotifEnableChange(newValue: boolean) {
    this.NOTIF_ALL_ENABLE = newValue;
  }

  quitSelectLanguage(){
    this.createproject = 7;
  }

  quitLanguage(){
    this.createproject = 2;
    this.edit = false;
  }

  quitContact(){
    this.createproject = 2;
    this.edit = false;
  }

  onGroupCreatedBloc(result: any): void {
    this.createproject = null; 
    if (result){ 
      const bgColor = this.getRandomColor();
      this.projectLists.unshift(result);
      this.total_project = this.total_project + 1;
      this.projectLists[0].randomColor = bgColor;
      this.projectLists[0].textColor = this.darkenColor(this.projectLists[0].color);
      var usersinvited = [];
      if(result.userProject.length > 0){
        result.userProject.forEach(element => {
          if(element.user && element.user.id && element.status == "PENDING") usersinvited.push(element.user.id);
          
        })
      }
      this.socketService.sendInstant({
        id: "0",
        action: "0",
        type: "INVITATIONPROJ",
        author: this.currentUser,
        recipient: result.creator.fullName,
        text: "",
        copy: usersinvited,
        private: false,
        res: "",
        project_lib: result.libelle,
        date: result.dateCreated
      });
      this.showtooltip = false;
      if(result.type !== "CHILD") this.projectListsParent.unshift(result)
      this.currentProjectId = result.id;
      this.projectChosen.emit(result.id);
      this.initIoConnection(result.id);
      this.projectMap[result.id] = 0;
      this.projectMapFace[result.id] = 0;
      this.messageService.setProjectMap(this.projectMap);
      this.messageService.setProjectMapFace(this.projectMapFace);
      this.router.navigate(['/project/'+result.id]);
    }
  }

  onGroupCreated(result: any): void {
    console.log("onGroupCreated")
    this.createproject = null; 
    if (result){ 
      const bgColor = this.getRandomColor();
      this.projectLists.unshift(result);
      this.projectLists[0].randomColor = bgColor;
      this.projectLists[0].textColor = this.darkenColor(this.projectLists[0].color);
      var usersinvited = [];
      if(result.userProject.length > 0){
        result.userProject.forEach(element => {
          if(element.user && element.user.id && element.status == "PENDING") usersinvited.push(element.user.id);
          
        })
      }
      this.socketService.sendInstant({
        id: "0",
        action: "0",
        type: "INVITATIONPROJ",
        author: this.currentUser,
        recipient: result.creator.fullName,
        text: "",
        copy: usersinvited,
        private: false,
        res: "",
        project_lib: result.libelle,
        date: result.dateCreated
      });
      if(result.type !== "CHILD") this.projectListsParent.unshift(result)
      this.currentProjectId = result.id;
      this.projectChosen.emit(result.id);
      this.initIoConnection(result.id);
      this.projectMap[result.id] = 0;
      this.projectMapFace[result.id] = 0;
      this.messageService.setProjectMap(this.projectMap);
      this.messageService.setProjectMapFace(this.projectMapFace);
      this.router.navigate(['/project/'+result.id+'/openmsg']);
    }
  }

  chooseGroupType(): void {
    this.authServices.changeStepProject.next("1");
    this.createproject = 11;
  }

  openDialogOne2One(): void {
    this.createproject = 10;
  }
  
  openDialog(): void {
      this.createproject = 1;
      
  }

  openProfileDialog(idproject: any, libelle: string, imageUrl: string){
      const dialogRef = this.dialog.open(ProfileupdDialog, {
        panelClass: 'transferclass',
        backdropClass: 'custom-backdrop',
        height: "height: calc(-80px + 100vh);",
        data:{idProjet: idproject, libelle : libelle, img : imageUrl}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        //console.log('The dialog was closed result '+result);
        if(result){
          //TO Do dialog ajout membre 
          //this.fctAddMember();
          /*(<HTMLInputElement>document.getElementById('project_'+this.ID)).innerHTML = result.libelle;
          if (result.imagechanged) {
            const imageElement = document.getElementById('project_' + this.ID + '_images') as HTMLImageElement;
            if(imageElement) imageElement.src = this.getAvatarlUrl(result.imageUrl);
          }*/
          (<HTMLInputElement>document.getElementById('project_'+idproject)).innerHTML = result.libelle;
            this.socketService.sendInstant({
              id: "",
              action: idproject, // ID du projet
              type: "RENAMEPROJECT",
              author: this.currentUser, // peu importe 
              recipient: this.ongletId, // peu importe 
              text: "",
              copy: "",
              private: false,
              res: result.libelle, // le nouveau nom
              date: ""
            });
          if(this.currentProjectId && this.currentProjectId == idproject){
            this.messageService.setLibelleProject(result);
            //(<HTMLInputElement>document.getElementById('libproject_'+idproject)).innerHTML = result.libelle;
          }
          this.projectFull = result;
          this.updclicked = false;
          this.projectLists.forEach((value,index)=>{
            if(value.id==idproject) this.projectLists[index].libelle = result.libelle;
          });
        } 
      });
  }

  fctinfoProjet(idproject: any, libelle: string): void{
    
    const dialogRef = this.dialog.open(projectInfoDialog, {
      width: '500px',
      data: {"id" : idproject, "name": libelle}
    });
    dialogRef.afterClosed().subscribe(result => {
        if (result && result.deleteReturn) {
        }else if (result) {
          (<HTMLInputElement>document.getElementById('project_'+idproject)).innerHTML = result.libelle;
          if(this.currentProjectId && this.currentProjectId == idproject){
            this.messageService.setLibelleProject(result);
            //(<HTMLInputElement>document.getElementById('libproject_'+idproject)).innerHTML = result.libelle;
          }
          this.projectFull = result;
          this.updclicked = false;
          this.projectLists.forEach((value,index)=>{
            if(value.id==idproject) this.projectLists[index].libelle = result.libelle;
          });
          //this.authService.obRefreshProjet.next();
       }  

    });
    
  }

  onConfirmeDeleteAccount(){
    //alert("Votre compte a été désactivé avec succès.");

    //------------
    
    this.authServices.disableUser().subscribe(res => {
      alert("Votre compte a été désactivé avec succès.");
      this.socketService.sendInstant({
        id: '',
        action: '0',
        type: "DELETEACCOUNT",
        author: this.userData.id,
        recipient: this.userData.id,
        text: '',
        copy: "",
        private: false,
        res: "",
        project_lib: "",
        date: ""
      });
      this.authServices.logout();
      //to DO HEEEEEEEEEEEERE
    },
    error => {
      alert("oups une erreur s'est produite!");
    }); 
    
  }

  confirmDelete(){
    /*if(confirm("Voulez vraiment suppprimer le projet "+libelle)) {
      this.onClickConfirmeDelete(id, libelle);
    }*/
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
           data: { 
             message: 'Voulez vous vraiment suppprimer votre compte ?',
             title: 'Confirmation'
           },
           panelClass: 'confirmclass',
           backdropClass: 'custom-backdrop'
         });
     
         dialogRef.afterClosed().subscribe(result => {
           if (result) {
            this.onConfirmeDeleteAccount();
           } else {
             //console.log('L\'utilisateur a annulé la suppression');
           }
    });
  }

  notifActivated(projectId){
    if(!this.NOTIF_ALL_ENABLE) return false;
    const project = this.projectLists.find(p => p.id === projectId);
    return project && project.userProject.length > 0
    ? project.userProject[0].notificationsEnabled !== false
    : true; 
  }

  desableNotif(projectId, userprojectId, item){
    this.authServices.desableNotifProjet(userprojectId, item).subscribe(dataAccepte => {
      const project = this.projectLists.find(item => item.id === projectId);
      if (project && project.userProject && project.userProject.length > 0) {
        project.userProject[0].notificationsEnabled = item;
        this.cdr.detectChanges();
      } else {
        console.warn('dossier ou userProject non trouvé');
      }
      this.updDialog();
      }, (error) => {
        //alert('une erreur est survenue');
    });
  }

  clickSuppMethod(id, libelle) {
    /*if(confirm("Voulez vraiment suppprimer le projet "+libelle)) {
      this.onClickConfirmeDelete(id, libelle);
    }*/
    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
           data: { 
             message: 'Voulez vraiment suppprimer le dossier '+libelle,
             title: 'Confirmation'
           },
           panelClass: 'confirmclass',
           backdropClass: 'custom-backdrop'
         });
     
         dialogRef.afterClosed().subscribe(result => {
           if (result) {
            this.onClickConfirmeDelete(id, libelle);
           } else {
             //console.log('L\'utilisateur a annulé la suppression');
           }
    });
  }

  onClickConfirmeDelete(id, libelle): void{
    this.authServices.deleteProject(id).subscribe(
      res => {  
        this.perPage -= 1;
        this.socketService.sendInstant({
            id: id,
            action: id,
            type: "DELPROJECT",
            author: this.userData.fullName,
            recipient: this.userData.id,
            text: '',
            copy: "",
            private: false,
            res: "",
            project_lib: libelle,
            date: ""
        });
        this.init_total_project--;
        if(this.filterRead == 'all') this.total_project = this.init_total_project;
        /*
        document.getElementById('project_'+id).parentElement.parentElement.parentElement.remove();
        //alert("Le projet a été supprimé par l'admin!!");
        if(this.messageService.getProjectid() == id){
          this.router.navigate(['/homes']);
        }*/
      },
      (error) => {
        alert('Erreur ! : ' + error)
      }
    );
  }

  onGroupSelected(result: any): void {
    //this.createproject = null; 
    console.log("onGroupSelected")
    if (result){ 
      this.fctprojectChosen(result.id, result.libelle, result.imageUrl, result);
    }
  }

  onGroupAccepted(result: any): void {
    //this.createproject = null; 
    if (result) {
      this.messageService.setProjectid(result.project.id);
      this.projectChosen.emit(result.project.id);
      this.authServices.obProjetAdded.next(result.project);
      this.authServices.getUserInvitation(0, 10).subscribe(res => {
        this.authServices.obInviteBadge.next(res);
      });
      this.messageService.messageUpdated();
      this.quitCreateProject(null);
      //this.router.navigate(['/project/' + result.project.id+'/openmsg']);
      this.router.navigate(['/project/' + result.project.id]);
    }

  }

  fctprojectChosenSearch(projectId, libelle, url){
    if(this.messageService.getProjectid() == projectId && (this.inProject == true) && (this.inFace == true)){
      this.authServices.obchangeinterface.next(1);
    }
    //this.authServices.initHeader.emit("1");
    this.currentProjectId = projectId;
    this.projectId = projectId;
    this.messageService.setProjectid(projectId);
    this.projectChosen.emit(projectId);
    this.projectChanged.emit(libelle);
    if(url){
      this.imageChanged.emit(url);
    } else {
      this.imageChanged.emit(null);
    }
    const instantbtn = document.getElementById('instant_lib') ;
    if (!instantbtn) {
      this.inFace = true;
    }
    if(this.inFace) {
      this.authServices.scrollTop.next("1")
    }
    const nbr_messages = this.displayedProjects.filter(item => item.id == projectId)[0].userProject[0].number;
    if(this.projectLists.filter(item => item.id == projectId)[0]){
      const nbr_messages2 = this.projectLists.filter(item => item.id == projectId)[0].userProject[0].number;
      this.authServices.obreadMessage.next(nbr_messages);
      this.authServices.updateNotifications(nbr_messages);
      this.projectLists.filter(item => item.id == projectId)[0].userProject[0].number = 0;
      this.calculateTotalNotifications();
    }
    this.displayedProjects.filter(item => item.id == projectId)[0].userProject[0].number = 0;
    //this.router.navigate(['/project/'+projectId]);
    this.router.navigate(['/project/'+projectId]);
    //this.router.navigate(['/project/'+projectId+'/openmsg']);
    
  }

  //TO DO HEEERE IF ALL RENITIALISER LE LIMIT OFFSET 
  loadPartProjects(loaded = null) {
      var progress = 0;
      var start = 0;
      if(this.projectLists.length > 0 && !loaded){
        this.perPage = this.projectLists.length;
        start = this.perPage;
        this.pageIndex = 2;
        this.loadingMessagesTop = true;
      } else this.projectLists = [];
      console.log("perpage : "+this.perPage+" offset : "+start)
      //var uri = '/projects?perPage='+this.perPage+'&page='+this.pageIndex+'&order[motionAt]=desc';
      var uri = '/fullprojects?limit='+this.perPage+'&offset='+start+'&order[motionAt]=desc';
      this.authServices.getProjects(uri).subscribe(res => {
        var result = res['hydra:member'];
        var lengthresults = res['hydra:totalItems'] ;
        //this.total_project = lengthresults;
        if(result.length == 0 && this.pageIndex == 1) {
          this.showtooltip = true;
          this.showtooltiplang = 1;
          //this.authServices.endLoading.emit("1");
        }
        progress += 5;  // 100 / 20
        if(lengthresults == 0 && this.pageIndex == 1) this.authServices.endLoading.next("1");
        const observables = result.map((value, index) => {
          return new Observable((observer) => {
            value.userProject = value.userProject.filter(userProject => {
              return userProject.user && userProject.user.id === this.currentUser;
            });
            this.projectMapFace[value.id]=value.userProject[0].face;
            if(this.pageIndex === 1) this.authServices.updateProgress(progress);
              observer.next(); // Signaler la fin de l'observable
              observer.complete();
            /*
            this.updateProjectNotifications(value.id).subscribe((total) => {
              this.projectMapFace[value.id]=total;
              if(this.pageIndex === 1) this.authServices.updateProgress(progress);
              observer.next(); // Signaler la fin de l'observable
              observer.complete();
            });*/
          });
        });
        forkJoin(observables).subscribe(() => {
          /*
          result = result.sort(function (a, b) {
            if (a.userProject[0].lastmsg > b.userProject[0].lastmsg) { return -1; }
            if (a.userProject[0].lastmsg < b.userProject[0].lastmsg) { return 1; }
            return 0;
          })*/
          this.loadingMessagesTop = false;
          this.authServices.endLoading.next("1");
          if(loaded) this.projectLists = [];
          this.projectLists = this.projectLists.concat(result);
          this.projectLists.forEach(project => {
            const bgColor = this.getRandomColor();
            project.randomColor = bgColor;
            project.textColor = this.darkenColor(project.color);
          });
          this.messageService.setListProject(this.projectLists);
          this.messageService.setProjectMapFace(this.projectMapFace);
          this.calculateTotalNotifications();
          this.isdataloaded == false;
          if(!result || result.length == 0 || result.length < this.perPage) this.canloadagain = false;
          setTimeout(() => {
            this.restoreScrollPosition();
          }, 0);
        });
        //if(this.projectLists.length == 0) this.authServices.endLoading.next("1");
      });
    }

  onScrollAll(event: any): void { // TO DO 
    if(this.filterRead !== "all" || this.projectLists.length == 0) return;
    const container = this.scrollMeproj.nativeElement;
    //const atTop = container.scrollTop > (container.scrollHeight - (container.scrollHeight / 3));
    const atTop = container.scrollHeight - container.scrollTop - 100 < container.clientHeight;
    //if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
    if (atTop && this.canloadagain && this.isdataloaded == false) {
      this.isdataloaded = true;
      this.scrollposition = container.scrollHeight;
      this.loadPartProjects();
    }
  }

  restoreScrollPosition() {
    if(this.scrollMeproj){
      const container = this.scrollMeproj.nativeElement;
      container.scrollTop = this.scrollposition - 50;
      this.isdataloaded = false;
    }
  }

  scrollToTop() {
    //window.scrollTo({ top: 0, behavior: 'smooth' });
    //this.myList.scrollToIndex(0, 'smooth');
    //const container = this.scrollMeproj.nativeElement;
    //this.scrollMeproj.nativeElement.scrollTop = -50;
    if (this.scrollMeproj) {
      this.scrollMeproj.nativeElement.scrollTop = 0;
      //this.scrollMeproj.nativeElement.scrollToTop();
    }
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  openDialogInfo(){
    const dialogRef = this.dialog.open(tutoCreateProjectdialog, {
      width: '850px',
      data:{}
    });
    dialogRef.afterClosed().subscribe(result => {
    })
  }


}


@Component({
  selector: 'app-dashboarddialog',
  templateUrl: 'dashboarddialog.component.html',
   styleUrls: ['dashboarddialog.component.scss']
})
export class dashboarddialogCompo implements OnInit{
  

  //@ViewChild('stepper') stepper: MatStepper;
  @ViewChild('addProjectForm', {static: true}) addProjectForm;
  firstFormGroup: FormGroup;
  //firstFormGroupOne: FormGroup;
  firstFormGroupTwo: FormGroup;
  projetNameOnemodel = "";
  projetNameOne: string = '';
  objectif: string = '';
  deadline = null;
  tagNameOne: string = '';
  addingTagMember = [];
  tagListadded = [];
  tagMemberAffected = [];
  tagUserSelected = [];
  addingMember = [];
  hasMemberAdding = false;
  projectUsers = [];
  userStatus = [];
  project = {
    name: 'Projet A',
    topics: ['Sujet 1', 'Sujet 2', 'Sujet 3']
  };
  subjectGroup = [];
  projectId = null;
  projects: Array<any> = [];
  members: Array<any> = [];
  tags: Array<any> = [];
  projectDetails = null;
  contacts = [];
  fromcsv = false;
  searchContact: any;
  searchTagContact: any;
  arrayEmailInvitation = [];
  arrayEmailInvitationWithId = [];
  arraySubject = [];
  groupselected = 0;
  confirm = 0;
  public projectCtrl: FormControl = new FormControl();
  saveProject = null;
  firstLoad = false;
  newProjectSubject = '';
  secteur = 'clients'
  currenteDate: any;
  showComfirmMessage = false;
  protected _onDestroy = new Subject<void>();
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  tagFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  createProjectMode = 3;
  default = true;
  SubNum = 0;
  memberdialog = 0;
  addcontactshow = 0;
  mailInputShow = 0;
  contactemail = '';
  inputemail = '';
  contactnom = '';
  contactprenom = '';
  emailPattern: string = '^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$';
  dupplicatestyle = 1;
  stepstyle = 0;
  projectFilter = "0";
  typeproject = '2';
  mailadded = "";
  duppselected = 1;
  projecttype = "PARENT";
  currentUser = null;
  @ViewChild('firstnextstep', {static: false}) firstnextstep: MatButton;
  @ViewChild('fileInputdash', {static: false}) fileInput: ElementRef;
  //@ViewChild('fileInput') fileInput;
  btnclicked = false;
  btntagclicked = false;
  @Input() data: any;
  @Input() one2one: any;
  img: any;
  imageFil = null;
  @Output() groupCreated = new EventEmitter<void>();
  @Output() groupCreatedBloc = new EventEmitter<void>();
  @Output() groupSlected = new EventEmitter<any>();
  @Output() groupQuit = new EventEmitter<void>();
  @Output() forwardToDashnav = new EventEmitter<any>();
  pageIndex = 1;
  perPage = 50;
  @ViewChild('scrollprojDupp', { static: false }) scrollprojDupp: ElementRef;
  @ViewChild('scrollprojDuppSearch', { static: false }) scrollprojDuppSearch: ElementRef;
  isdataloaded = false;
  canloadagain = true;
  isdataloadedsearch = false;
  loadingDuppTop = false;
  scrollposition = 0;
  scrollpositionsearch = 0;
  searchProjectDupp : any = null;
  private searchTermsDupp = new Subject<string>();
  pageSearch = 1;
  displayedProjectsDupp: Array<any> = [];
  canloadagainsearch = true;
  total_projects = 0;
  public minDate = new Date();
  show_members = true;
  
  vibrantColors = [
    "#e7e0ff", // bleu très clair
    "#caf1ee", // vert très clair
    "#fff0d3", // orange clair
    "#fbd8dc", // rose clair  #fdc1c8
    "#d8fdd2", // violet clair
    "#f4ded1", // turquoise clair   fdc1c8
    "#d1e8ff", // mauve clair
    "#cbf2ef"
  ];

  colorMap: Record<string, string> = {
    '#e7e0ff': '#5d45de', // bleu → violet foncé
    '#caf1ee': '#008476', // vert → vert foncé
    '#fff0d3': '#9d6b2b', // orange → brun
    '#fbd8dc': '#cd0635', // rose → bordeaux
    '#d8fdd2': '#1c8555', // vert → vert foncé
    '#f4ded1': '#855436', // beige → marron
    '#d1e8ff': '#0060d3', // bleu → bleu foncé
    '#cbf2ef': '#008379'  // turquoise → turquoise foncé
  };

  constructor(
    //public dialogRef: MatDialogRef<dashboarddialogCompo>,
    //@Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
    private messageService: MessageService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private cdr: ChangeDetectorRef,
    private socketService: SocketService,
    private _formBuilder: FormBuilder) {

      /*this.authService.getContacts().subscribe( dataContact => {
        this.contacts = dataContact['hydra:member'];
      });*/
      //console.log("one to one "+this.one2one)
      this.contacts = [];
      this.total_projects = this.messageService.getTotalProject();
      console.log("reees "+this.messageService.getTotalProject())
      this.loadPartProjects();
      this.currentUser = JSON.parse(localStorage.getItem('currentUser'));
      //this.projects = data.projects;
      this.loadContact();
      this.projectCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterProject();
      });
      

      /*
      let userStatus = []; 
        for (let index = 0; index < this.projectUsers.length; index++) {
          if(this.projectUsers[index]['user'])
          userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];
        }
      this.userStatus = userStatus;*/
      
    }

  showHideMembers(){
    this.show_members = !this.show_members;
  }

    
  scrollRight(container: HTMLElement) {
    container.scrollBy({ left: 100, behavior: 'smooth' });
  }

  scrollLeft(container: HTMLElement) {
    container.scrollBy({ left: -100, behavior: 'smooth' });
  }

  getRandomColor(): string {
    const randomIndex = Math.floor(Math.random() * this.vibrantColors.length);
    return this.vibrantColors[randomIndex];
  }

  getInitials(libelle: string): string {
    const words = libelle.split(' ');
    const getFirstChar = (word: string): string => {
      return word.trim().charAt(0).toUpperCase();  // Récupère le premier caractère du mot
    };
    const initials = words.slice(0, 2).map(word => getFirstChar(word)).join('');  // Joint avec un point

    return initials;
  }

    onScrollsearch(event: any): void { // TO DO 
      const container = this.scrollprojDuppSearch.nativeElement;
      const atTop = container.scrollTop > (container.scrollHeight - (container.scrollHeight / 3));
      //if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
      if (atTop && this.canloadagainsearch && this.isdataloadedsearch == false) {
        this.isdataloadedsearch = true;
        this.scrollpositionsearch = container.scrollHeight;
        this.getSearchProjects();
      }
    }

    onSearchDupp() {
      if (this.searchProjectDupp.trim() === '' || this.searchProjectDupp == null) {
        this.searchProjectDupp = null;
      } else this.searchTermsDupp.next(this.searchProjectDupp);
      /*
      var shownprojects = [...this.projectLists];
      this.displayedProjects = this.filterLocalProjects(shownprojects, this.searchProject);
      
      this.authServices.searchProjects(this.searchProject).subscribe(serverResults => {
        this.displayedProjects = [];
        this.displayedProjects = this.mergeResults(this.displayedProjects, serverResults['hydra:member']);
        //this.displayedProjects = serverResults['hydra:member'];
      });*/
    }

    onDateSelected(event: any): void {
          const selectedDate = event.value; // ✅ utiliser event.value, pas event.target.value
    
          if (selectedDate) {
            // Format avec moment
            this.deadline = moment(selectedDate).format('DD-MM-YYYY').toLocaleString();
          }
    }

    getSearchProjects() {
      var shownprojects = [...this.displayedProjectsDupp];
      this.pageSearch += 1;
      this.authService.searchProjects(this.searchProjectDupp, this.pageSearch).subscribe((res)=>{
        //this.displayedProjects.concat(res['hydra:member']);
        this.displayedProjectsDupp = [...this.displayedProjectsDupp, ...res['hydra:member']]
        if(res['hydra:member'].length < 20){
          this.canloadagainsearch = false;
        }
        setTimeout(() => {
          this.restoreScrollPositionSearchDupp();
        }, 0);
      });
    }

    restoreScrollPositionSearchDupp() {
      const container = this.scrollprojDuppSearch.nativeElement;
      container.scrollTop = this.scrollpositionsearch - 50;
      this.isdataloadedsearch = false;
    }

    onScrollDupp(event: any): void { // TO DO 
      const container = this.scrollprojDupp.nativeElement;
      //const atTop = container.scrollTop > (container.scrollHeight - (container.scrollHeight / 3));
      const atTop = container.scrollHeight - container.scrollTop - 100 < container.clientHeight;
      //if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
      if (atTop && this.canloadagain && this.isdataloaded == false) {
        this.isdataloaded = true;
        this.scrollposition = container.scrollHeight;
        this.loadPartProjects(true);
      }
    }

    onScrollDuppSearch(event: any): void { // TO DO 
      const container = this.scrollprojDuppSearch.nativeElement;
      //const atTop = container.scrollTop > (container.scrollHeight - (container.scrollHeight / 3));
      const atTop = container.scrollHeight - container.scrollTop - 100 < container.clientHeight;
      //if (atTop && !this.loadingMessagesTop && this.dataloaded == false && this.startedPoint == false && this.canload == true) {
      if (atTop && this.canloadagain && this.isdataloaded == false) {
        this.isdataloaded = true;
        this.scrollposition = container.scrollHeight;
        this.loadPartProjects(true);
      }
    }

    loadPartProjects(loaded = null) {
      var progress = 0;
      if(this.projects.length > 0){
        this.perPage = this.projects.length;
        this.pageIndex = 2;
        this.loadingDuppTop = true;
      }
      var uri = '/projects?perPage='+this.perPage+'&page='+this.pageIndex+'&order[motionAt]=desc';
      this.authService.getProjects(uri).subscribe(res => {
        var result = res['hydra:member'];
        var lengthresults = res['hydra:totalItems'] ;
        this.total_projects = lengthresults;
        console.log('resssss '+lengthresults)
          this.loadingDuppTop = false;
          this.projects = this.projects.concat(result);
          this.isdataloaded == false;
          if(!result || result.length == 0 || result.length < this.perPage) this.canloadagain = false;
          setTimeout(() => {
            this.restoreScrollPositionDupp();
          }, 0);
        });
    }

    restoreScrollPositionDupp() {
      if(this.scrollprojDupp && this.scrollprojDupp.nativeElement){
        const container = this.scrollprojDupp.nativeElement;
        container.scrollTop = this.scrollposition - 50;
        this.isdataloaded = false;
      }
    }

    triggerFileInputClick(): void {
      this.addingMember = [];
      this.tagMemberAffected = [];
      this.confirm = 0;
      this.mailInputShow = 0;
      this.inputemail ='';
      this.fileInput.nativeElement.click();
    }
  
    onFileSelected(event: any): void {
      const file: File = event.target.files[0];
  
      if (file) {
        const reader = new FileReader();
  
        reader.onload = (e: any) => {
          const csv: string = e.target.result;
          this.processCSV(csv);
        };
  
        reader.readAsText(file);
      }
    }

    onProfilePicClick(): void {
      const fileInput = document.getElementById('fileInput') as HTMLElement;
      fileInput.click();
    }

    fctAddByCsvValue(email=null, name=null, lastName=null, metier=null) {
      // stop here if form is invalid
      if (email == '' || (email == JSON.parse(localStorage.getItem('currentUser'))['email'])) {
        return;
      }
  
      if (this.contacts.find(i => i.email === email)){
        //this.addingMember.push(newUser);
        //this.addingMember.push(this.contacts.find(i => i.id === newUser.id));
        var newUser = this.contacts.find(i => i.email === email);
        this.addingMember.push(newUser);
        this.userStatus[newUser['email']] = 'PENDING';
        this.hasMemberAdding = true;
      } else {
        this.addingMember.push({"email": email, "familyName": "", "fullName": lastName+" "+name, "interne": false});
        //this.addingMember.push({"givenName": email, "familyName": "", "interne": false, "name": name, "lastName": lastName, "metier": metier}); 
        this.hasMemberAdding = true;
      }
  
    }

    processCSV(csv: string): void {
      const lines = csv.split('\n'); // Séparer par lignes
      this.members = [];
      this.addingMember = [];
      this.fromcsv = false;

      for (let i = 1; i < lines.length; i++) {
        const line = lines[i];
        const fields = line.split(';'); // Séparer par colonnes
        if (fields.length === 4) { // Assurez-vous qu'il y a trois colonnes
          const email = fields[0].trim();
          const name = fields[1].trim();
          const lastName = fields[2].trim();
          const metier = fields[3].trim();
          this.fctAddByCsvValue(email, name, lastName, metier);
        }
      }
      return;
    }
  
    processCSV2(csv: string): void {
      const emails = csv.split(';');
      this.members = [];
      this.addingMember = [];
      //emails.shift();
      emails.forEach(email => {
        this.fctAddByCsvValue(email.trim());  
        //console.log(email.trim())
      });
    }

    protected filterProject() {
      if(this.saveProject == null){
        this.saveProject = this.projects;
      }
  
      let search = this.projectCtrl.value;
      if (!search) {
        this.projects = this.saveProject;
        return;
      } else {
        search = search.toLowerCase();
        this.projects = this.saveProject.filter(bank => bank.libelle.toLowerCase().indexOf(search) > -1);
      }
    }

    ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
    }

    goBackName(){
      this.createProjectMode = 1;
      this.addcontactshow = 0;
    }

    goBackTypeProject(){
      this.createProjectMode = 3;
    }

    showOne2One(){
      this.createProjectMode = 40;
      this.hideMailInput();
    }

    goBackToName(){
      this.btnclicked = false;
      this.confirm = 0;
      this.default = true;
      this.addingMember = [];
      this.hideMailInput();
      this.createProjectMode = 3;
    }

    goBackChoice(){
      this.addcontactshow = 0;
      if(this.confirm == 1){
        this.confirm = 0;
        this.addingMember = [];
      } else {
        this.addingMember = [];
        this.confirm = 0;
        this.createProjectMode = 3; 
      }
      this.hideMailInput();
      return;
    }

    returnToOne2one(){
      this.createProjectMode = 3;
      this.hideMailInput();
    }

    quitCreateProject(value = null){
      if(this.addcontactshow){
        this.addcontactshow = 0;
      } else this.groupQuit.emit(value);
    }

    selectFromContacts(){
      this.createProjectMode = 33;
    }

    validateUsers(){
      this.createProjectMode = 3;
    }

    goToSimpleMap(){
      
      if (this.projetNameOne.length > 0 ){
        this.authService.existProject(this.projetNameOne).subscribe(res => {
          //console.log('retour liste project!!! ');
          var resultat = ''+res;
          if(resultat === 'true'){
            alert("Ce projet existe déjà");
            return;
          } else this.createProjectMode = 103;
        });  
      
      } 
    }

    goToMembers(){
      this.authService.existProject(this.projetNameOne).subscribe(res => {
          //console.log('retour liste project!!! ');
          var resultat = ''+res;
          console.log("deadline "+this.deadline)
          console.log("objectif "+this.objectif)
          if(resultat === 'true'){
            alert("Ce projet existe déjà");
            return;
          } else {
            this.authService.changeStepProject.next("2");
            this.default = true;
            this.createProjectMode = 103;
          }
      });  
    }

    showDuppImport(){
      this.addingMember = [];
      this.default = !this.default;
    }

    newProject(value = null){
      this.createProjectMode = 3;
      //this.groupQuit.emit(value);
    }

    showEmailInvited(){
      this.addcontactshow = 1;
      this.contactemail = '';
    }

    isEmailValid(email: string): boolean {
      const regex = new RegExp(this.emailPattern);
      return regex.test(email);
    }


    inviteNewMail(){
      if(this.inputemail.trim().length > 0){
        this.memberdialog = 1;
        this.verifMailExist(this.inputemail.trim());  
      }
      /*
      const dialogRef = this.dialog.open(dashboardmemberdialog, {
        panelClass: 'dashboarddialog-container',
        data: {idcompany: 1, companyUser: this.contacts}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.verifMailExist(result);  
      });*/
    }

    inviteMail(){
      if(this.contactemail.trim().length > 0){
        this.memberdialog = 1;
        this.verifMailExist(this.contactemail.trim());  
      }
      /*
      const dialogRef = this.dialog.open(dashboardmemberdialog, {
        panelClass: 'dashboarddialog-container',
        data: {idcompany: 1, companyUser: this.contacts}
      });
  
      dialogRef.afterClosed().subscribe(result => {
        this.verifMailExist(result);  
      });*/
    }

    verifMailExist(mail) {

      // stop here if form is invalid
      if (mail == '') {
        return;
      }
  
      var result = mail;
  
   
       this.authService.getUserInfo(result).subscribe(
          res => {
            
            var arrayUser = res["hydra:member"];
            
            if (arrayUser.length > 0 ) {
              var newUser = arrayUser[0];
              var contact = this.contacts.find(i => i.id === newUser.id);
              if (contact){
                this.CreateOneToOne(contact);
              } else {
                this.contacts.push(newUser);
                this.CreateOneToOne(newUser);
              }
            }
            else
            {
              this.createOnetoOneProject(null, mail); 
            }
            this.hideMailInput();
            this.searchContact = "";
          },
          (error) => {
            alert('Erreur ! : ' + error)
          }
        );
    }

    chooseTypeProject(){
      if (this.projetNameOne.trim().length > 0 ){
        this.authService.existProject(this.projetNameOne.trim()).subscribe(res => {
          //console.log('retour liste project!!! ');
          var resultat = ''+res;
          if(resultat === 'true'){
            alert("Ce projet existe déjà");
          } else {
            this.createProjectMode = 3; 
            this.typeproject = '2';
            this.dupplicatestyle = 1;
            this.projecttype = "CHILD";
          }
        });      
      }
    }

    CreateOneToOne(contact = null){
      if(!contact) return;
      if (contact.fullName.trim().length > 0 ){
        this.authService.existPrivateProject(contact.email).subscribe(res => {
          var resultat = ''+res;
          if(resultat === 'false'){
            this.createOnetoOneProject(contact);
          } else {
              for (let userProject of res["userProject"]) {
                if (userProject.user && userProject.user.id === this.currentUser.id && userProject.status == "PENDING") {
                  /*if(confirm("Une invitation de cet utilisateur est déjà en attente. Voulez-vous l'accepter ?")) {
                    this.onClickAccepter(userProject.id, res);
                  }*/
                    const dialogRef = this.dialog.open(ConfirmdialogComponent, {
                      data: { 
                        message: 'Une invitation de cet utilisateur est déjà en attente. Voulez-vous l\'accepter ?',
                        title: 'Confirmation'
                      },
                      panelClass: 'confirmclass',
                      backdropClass: 'custom-backdrop'
                    });
                
                    dialogRef.afterClosed().subscribe(result => {
                      if (result) {
                        this.onClickAccepter(userProject.id, res);
                      } else {
                        //console.log('L\'utilisateur a annulé la suppression');
                      }
                    });

                  return;
                } else if(userProject.user && userProject.user.id === this.currentUser.id && userProject.status == "ACCEPTED"){
                  this.groupSlected.emit(res);
                }
              }
          }
        });  
      }
    }

    onClickAccepter(invitationID, res) {
      var projectId = res["id"];
      this.authService.accepterProjet(invitationID).subscribe(dataAccepte => {
        this.socketService.sendInstant({
          id: "0",
          action: "0",
          type: "PROJECTINVITATION",
          author: this.currentUser.id,
          author_name: "",
          recipient: projectId,
          text: "",
          copy: "",
          private: false,
          res: "",
          project_lib: "",
          date: ""
        });
        this.groupCreated.emit(res);
        this.fromcsv = false;
        this.btnclicked = true;
        //this.authService.obProjetAdded.next(dataAccepte);
        this.authService.getUserInvitation(0, 10).subscribe(res => {
          this.authService.obInviteBadge.next(res);
        });
      }, (error) => {
        alert('une erreur est survenue');
      });
    }

    createOnetoOneProject(contact = null, email = null){
      if(!contact && !email) return;
      this.btnclicked = true;
      
      let arrayUserProject = [];
      var id = null;
      var fullName = email;
      if(contact) {
        id = contact.id;
        fullName = contact.fullName
        arrayUserProject.push({"user":"/api/users/"+contact.id, "isAdmin": true});
      }
      if(email) {
        arrayUserProject.push({"email":email, "prenom": "", "nom": "", "metier": "", "isAdmin": true});
      }
      
      this.authService.createProject(fullName, null, null, null, arrayUserProject, this.projecttype, null, null, false, true, id).subscribe(
        res => {
          this.projectDetails = res;
          this.projectId = res['id'];
          this.groupCreated.emit(this.projectDetails);
          this.messageService.setTotalProject(this.messageService.getTotalProject() + 1);
          this.fromcsv = false;
          this.btnclicked = true;
          this.total_projects = this.total_projects + 1;
        },
        (error) => {
          alert('Erreur ! : ' + error);
          this.btnclicked = false;
        }
      );

    }

    nextStepGroupMember(){
      this.createProjectMode = 5; 
      this.typeproject = "2";
    }

    mergeResults(localResults: any[], serverResults: any[]): any[] {
      const existingIds = new Set(localResults.map(item => item.id));
      const filteredServerResults = serverResults.filter(item => !existingIds.has(item.id));
      return [...localResults, ...filteredServerResults];
    }

    searchProjects() {
      this.pageSearch = 1;
      return this.authService.searchProjects(this.searchProjectDupp).pipe(
        map(serverResults => {
          return serverResults;
        })
      );
    }

    setupSearchSubscription() {
      this.searchTermsDupp.pipe(
        debounceTime(50), // Adjust the debounce time as needed
        switchMap(() => this.searchProjects())
      ).subscribe(results => {
        this.displayedProjectsDupp = [];
        this.displayedProjectsDupp = results['hydra:member'];
      });
    }

    ngOnInit() {
      this.tagListadded = [];
      this.addcontactshow = 0;
      this.secteur = localStorage.getItem('secteur');
      this.setupSearchSubscription();
      this.arrayEmailInvitation = [];
      this.arrayEmailInvitationWithId = [];
      this.addingMember = [];
      this.tagMemberAffected = [];
      //this.createProjectMode = 3;
      this.createProjectMode = 3;
      this.currenteDate = new Date();
      this.firstFormGroup = this._formBuilder.group({
        projetName: ['', ],
        clickCreate: ['', [Validators.required, Validators.requiredTrue]],
        objectif: [''],
        deadLine: [''],
        sujectList: [[]]
      });
      /*
      this.firstFormGroupOne = new FormGroup({
        projetNameOne: new FormControl('')
     });
     this.firstFormGroupOne = new FormGroup({
        projetNameOne: new FormControl('')
     });
      this.firstFormGroupOne = this._formBuilder.group({
        projetNameOne: ['', Validators.required]
      });*/
      this.firstFormGroupTwo = this._formBuilder.group({
        mailadded: ['', ]
      });
    }

    confirmGroup(){
      this.confirm = 1;
    }

    getGroupData(idProject){
      this.addingMember = [];
      this.tagMemberAffected = [];
      if (idProject != this.projectId) {
        this.projectId = idProject;
        //this.confirm = 1;
        this.loadMembers(idProject);
        //this.groupselected = 1;
      } else {
        this.groupselected = 0;
        this.projectId = null;
      }
      //set createProjectMode === 103 afetr selection of project
    }

    

    loadFilterElement(){
      if (this.firstLoad == true) {
        this.loadProject();
      }
      this.firstLoad = false;
    }

    getTags(){
         this.authService.getAllTags().then((res)=>{
         }).catch((err)=>{
           console.log(err)
         })
    }

    darkenColor(bgColor: string) {
      if (!bgColor) return '#444';
      const key = bgColor.toLowerCase().substring(0, 7);
      return this.colorMap[key] || '#444'
    }

    loadProject(url?: string) {
      url = url ? url : undefined;
      this.authService.getProjects(url).subscribe(res => {
        this.projects = this.projects.concat(res['hydra:member']);
        this.projects = this.projects.sort(function (a, b) {
            if (a.libelle.toLowerCase() < b.libelle.toLowerCase()) { return -1; }
            if (a.libelle.toLowerCase() > b.libelle.toLowerCase()) { return 1; }
            return 0;
        })
        if(res['hydra:view']['hydra:next']){
          this.loadProject(res['hydra:view']['hydra:next'].replace("/api", ""));
        }
      }); 
    }

    loadContact(url?: string) {
      url = url ? url : undefined;
      this.authService.getMyContacts(this.currentUser['compId']).subscribe(res => {
        this.contacts = this.contacts.concat(res['hydra:member']);
        /*this.contacts = this.contacts.sort(function (a, b) {
          if (a.fullName.toLowerCase() < b.fullName.toLowerCase()) { return -1; }
          if (a.fullName.toLowerCase() > b.fullName.toLowerCase()) { return 1; }
          return 0;
      })*/
      this.contacts.forEach((value,index)=>{
        value.interne = true;
        const bgColor = this.getRandomColor();
        value.color = bgColor;
        value.textColor = this.darkenColor(value.color);
        if(value.id== this.currentUser.id) this.contacts.splice(index,1);
      });
      });
    }

    onNoClick(): void {
    }

    goBack(): void {
      this.createProjectMode = 1;
      this.addcontactshow = 0;
      this.confirm = 0;
      this.addingMember = [];
      this.tagMemberAffected = [];
    }

    goBackListe(): void {
      this.addingMember = [];
      this.tagMemberAffected = [];
      this.addcontactshow = 0;
      this.confirm = 0;
      this.groupselected = 0;
      this.createProjectMode = 3;
      this.dupplicatestyle = 0;
      this.typeproject = '2';
      this.fromcsv = false;
    }

    handleProjectSubmit(data: any) {
      this.onDuppProject(data); // 👉 
    }


    onDuppProject(data){
      this.btnclicked = true;
      this.projetNameOne = data.libelle;
      this.firstFormGroup.patchValue({
        clickCreate: true 
      });

      if (this.projetNameOne.trim().length == 0 ){
        this.firstFormGroup.patchValue({
          projetName: '' 
        });
      } else {
        this.firstFormGroup.patchValue({
          projetName: this.projetNameOne.trim() 
        });
      }

      if (this.firstFormGroup.invalid) {
        this.firstFormGroup.patchValue({
          clickCreate: '' 
        });
        return;
      }

     
      let result = this.firstFormGroup.value;
      
      let arrayUserProject = [];
      //let arrayTagProject = [];
      let arrayTagProject = data.tags;
      var addingMember = data.userProject;
      for (var i = 0; i < addingMember.length; i++) {
          if(addingMember[i].id){
            if(addingMember[i].id != this.currentUser.id) arrayUserProject.push({"user":"/api/users/"+addingMember[i].id});
          } else {
            arrayUserProject.push({"email": addingMember[i].email, "prenom": addingMember[i].email, "nom": addingMember[i].email, "metier": ""});
          }
      }
      
      this.authService.duppProject(data.libelle, arrayTagProject, arrayUserProject, this.imageFil, this.objectif, this.deadline).subscribe(
        res => {
          this.projectDetails = res;
          this.projectId = res['id'];
          this.ignoreSubject(true);
          this.fromcsv = false;
          this.btnclicked = true;
        },
        (error) => {
          if (error.status === 403) {
            const errorDescription = JSON.parse(error.error['hydra:description']);
            this.openPackComponentDialog(1, errorDescription.subscriptionPack);
            this.btnclicked = false;
          } else if (error.status === 429) {
            this.openPackComponentDialog(3);
          } else if (error.status === 402) {
            const errorDescription = JSON.parse(error.error['hydra:description']);
            this.openPackComponentDialog(2, errorDescription.subscriptionPack);
            this.btnclicked = false;
          } else {
            alert('Erreur ! : ' + error);
            this.btnclicked = false;
          }
        }
      );

    }


    onSubmitProject(){
      this.btnclicked = true;
      this.firstFormGroup.patchValue({
        clickCreate: true 
      });

      if (this.projetNameOne.trim().length == 0 ){
        this.firstFormGroup.patchValue({
          projetName: '' 
        });
      } else {
        this.firstFormGroup.patchValue({
          projetName: this.projetNameOne.trim() 
        });
      }

      if (this.firstFormGroup.invalid) {
        this.firstFormGroup.patchValue({
          clickCreate: '' 
        });
        return;
      }

     
      let result = this.firstFormGroup.value;
      
      let arrayUserProject = [];
      let arrayTagProject = [];

      for (var i = 0; i < this.addingMember.length; i++) {
          if(this.addingMember[i].id){
            if(this.addingMember[i].id != this.currentUser.id) arrayUserProject.push({"user":"/api/users/"+this.addingMember[i].id});
          } else {
            arrayUserProject.push({"email": this.addingMember[i].email, "prenom": this.addingMember[i].email, "nom": this.addingMember[i].email, "metier": ""});
          }
      }
      
      this.authService.createProject(result.projetName, this.objectif, this.deadline, arrayTagProject, arrayUserProject, this.projecttype, this.projectId, this.imageFil, this.fromcsv).subscribe(
        res => {

          this.projectDetails = res;
          this.projectId = res['id'];
          this.ignoreSubject(true);
          this.fromcsv = false;
          this.btnclicked = true;
          this.messageService.setTotalProject(this.messageService.getTotalProject() + 1);
        },
        (error) => {
          if (error.status === 403) {
            //this.openPackComponentDialog(1);
            const errorDescription = JSON.parse(error.error['hydra:description']);
            this.openPackComponentDialog(1, errorDescription.subscriptionPack);
            this.btnclicked = false;
          } else if (error.status === 429) {
            this.openPackComponentDialog(3);
          } else if (error.status === 402) {
            const errorDescription = JSON.parse(error.error['hydra:description']);
            this.openPackComponentDialog(2, errorDescription.subscriptionPack);
            this.btnclicked = false;
          } else {
            alert('Erreur ! : ' + error);
            this.btnclicked = false;
          }
        }
      );

    }

    fctCheckMemberTag(userInfo){ 
      if(this.addingTagMember && !this.addingTagMember.includes(userInfo)){
        this.fctAdMemberTag(userInfo);
      } else this.fctRemoveUserTag(userInfo);
    }

    fctAdMemberTag(userInfo){ 
      this.addingTagMember.push(userInfo);
      this.searchTagContact = "";
    }

    fctRemoveUserTag(userInfo){
      const index = this.addingTagMember.indexOf(userInfo);
      if (index > -1) {
        this.addingTagMember.splice(index, 1);
        delete this.userStatus[userInfo['id']];
        this.searchTagContact = "";
      }
    }

    areAllSelected(): boolean {
      return this.addingTagMember.length === this.addingMember.length;
    }

    toggleAllUsers() {
      if (this.areAllSelected()) {
        this.dSelectAllUsers();
      } else {
        this.selectAllUsers();
      }
    }

    selectAllContacts(){
      this.addingMember = [];
      this.contacts.forEach((item) => this.addingMember.push(item));
    }
    deselectAllContacts(){
      this.addingMember = [];
    }

    selectAllUsers() {
      this.addingTagMember = [...this.addingMember]; // copie tous les membres
      this.searchTagContact = "";
    }

    dSelectAllUsers() {
      this.addingTagMember = [];
      this.searchTagContact = "";
    }

    ignoreSubject(value = false){
      this.tagListadded = [];
      this.tagMemberAffected = [];
      if(value) this.groupCreatedBloc.emit(this.projectDetails);
      else this.groupCreated.emit(this.projectDetails);
    }

    onQuitMap(newMode: number) {
      this.groupselected = 0;
      this.projectId = null;
      this.confirm = 0;
      this.addingMember = [];
      this.tags = [];
      this.mailInputShow = 0;
      this.createProjectMode = 3;
    }

    createSubject(){
      this.createProjectMode = 101;
    }

    goBackSoonProject(){
      this.createProjectMode = 100;
      this.tagMemberAffected = [];
    }

    goBackOtherSub(){
      this.createProjectMode = 102;
    }

    addTagToProject(){
      var general = false;
      if(this.tagNameOne.trim() == "" || this.tagNameOne.trim().length == 0){
        alert("Veuillez entrer un service");
        return;
      } 
      /*if(this.addingTagMember.length == 0 && !this.projectDetails.isPrivate){
        alert("Veuillez sélectionner au moins un membre avant de créer le projet.");
        return;
      }*/
      this.tagUserSelected = [];
      var tagUser = [];
      tagUser.push({"user":"/api/users/"+this.currentUser.id});
      for (var i = 0; i < this.addingTagMember.length; i++) {
        tagUser.push({"user":"/api/users/"+this.addingTagMember[i].id});
      }
      this.addingTagMember.map(item=> {
          //tagUser.push(item.id);
          this.tagUserSelected.push(item);
          this.tagMemberAffected.push(item);
      })
      this.authService.addTagToProject({
        libelle: this.tagNameOne,
        project: '/api/projects/'+this.projectDetails.id,
        isGeneral: false
      }, tagUser).then((res)=>{
        this.tagListadded.push(res);
        this.tagNameOne = "";
        this.addingTagMember = [];
        this.tagUserSelected = [];
        this.SubNum++;
        this.goBackOtherSub();
      }).catch(err=>{
        console.log(err)
      });
    }

    openPackComponentDialog(type = 0, currentPack = 'free'){
        this.btnclicked = false;
        const dialogRef = this.dialog.open(PackComponent, {
          panelClass: 'packclass',
          backdropClass: 'custom-backdrop-pack',
          height: "height: calc(-80px + 100vh);",
          data: { type: type, pack: currentPack}
        });
    
        dialogRef.afterClosed().subscribe(result => {
        });
      }

  validateClick(): void{
    this.addProjectForm.nativeElement.submit();
  }


  fctAddcontactByMail() {
    if (this.emailFormControl.status == 'INVALID') {
      return;
    }
    var result = this.emailFormControl.value;
     this.authService.getUserInfo(result).subscribe(
        res => {
          var arrayUser = res["hydra:member"];
          if (arrayUser.length > 0) {
            var newUser = arrayUser[0];
            this.addingMember.push(newUser);
            this.userStatus[newUser['id']] = 'PENDING';
            this.hasMemberAdding = true;
            this.emailFormControl.reset();
            this.arrayEmailInvitationWithId.push(result);  
          }
          else
          {
            this.arrayEmailInvitation.push(result);   
            this.hasMemberAdding = true;
            this.emailFormControl.reset();
          }
          this.searchContact = "";
        },
        (error) => {
          alert('Erreur ! : ' + error)
        }
      );

  }


  fctAddByMailValue() {

    // stop here if form is invalid
    if (this.inputemail == '') {
      return;
    }

    var result = this.inputemail;

 
     this.authService.getUserInfo(result).subscribe(
        res => {
          
          var arrayUser = res["hydra:member"];
          
          if (arrayUser.length > 0 ) {
            var newUser = arrayUser[0];
            newUser.interne = true;
            if (this.contacts.find(i => i.id === newUser.id)){
            //this.addingMember.push(newUser);
            //this.addingMember.push(this.contacts.find(i => i.id === newUser.id));
              if(!(this.addingMember.includes(this.contacts.find(i => i.id === newUser.id)))){
                this.addingMember.push(this.contacts.find(i => i.id === newUser.id));
                this.userStatus[newUser['id']] = 'PENDING';
                this.hasMemberAdding = true;
                this.emailFormControl.reset();
                this.arrayEmailInvitationWithId.push(result); 
                this.mailInputShow = 0;
                this.inputemail ='';
              }
            }  else { 
              this.addingMember.push(newUser);
              this.userStatus[newUser['id']] = 'PENDING';
              this.hasMemberAdding = true;
              this.emailFormControl.reset();
              this.mailInputShow = 0;
              this.inputemail ='';
            }
          }
          else
          {
            //this.arrayEmailInvitation.push();  
            //console.log("res "+result);
            //this.addingMember.push({"givenName": result, "familyName": "", "fullName": result, "interne": false}); 
            this.addingMember.push({"email": result, "familyName": "", "fullName": result, "interne": false}); 
            this.hasMemberAdding = true;
            this.mailInputShow = 0;
            this.inputemail ='';
            this.emailFormControl.reset();
          }
          
          this.searchContact = "";
         
        },
        (error) => {
          alert('Erreur ! : ' + error)
        }
      );

  }


  clickConfirm(){
    //this.dialogRef.close(this.projectDetails);
    this.createProjectMode = 4;
    this.showComfirmMessage = false; 
  }

  clickRefus(){
    this.showComfirmMessage = false;
  }

  goToSubject(){
    //console.log("Project ID go : "+this.projectDetails);
    if (this.projetNameOne.trim().length > 0 ){
      this.authService.existProject(this.projetNameOne.trim()).subscribe(res => {
        //console.log('retour liste project!!! ');
        var resultat = ''+res;
        if(resultat === 'true'){
          alert("Ce projet existe déjà");
        } else {
          this.createProjectMode = 2; 
        }
      });  
     
    }
    else
    {
      alert("Veuillez entrer un nom pour l'activité");
    }
   
  } 

  goToDupplicate(id: any){
    this.fromcsv = false;
    if ((this.projetNameOne.trim().length > 0 ) && id !== "0"){
      this.authService.existProject(this.projetNameOne.trim()).subscribe(res => {
        //console.log('retour liste project!!! ');
        var resultat = ''+res;
        if(resultat === 'true'){
          alert("Ce projet existe déjà");
        } else {
          this.createProjectMode = 3; 
          this.dupplicatestyle = id;
          if(id === 1){
            this.stepstyle = 1;
          }
        }
      }); 
    } else if (this.projetNameOne.trim().length === 0)
    {
      this.projectFilter = "0";
      alert("Veuillez entrer un nom pour l'activité" +this.projectFilter);
    } 
    /*
    //console.log("Project ID go : "+this.projectDetails);
    if (this.firstFormGroup.get('projetName').value.trim().length > 0 ){
       this.createProjectMode = 3; 
       this.dupplicatestyle = id;
    }
    else
    {
      alert("Veuillez entrer un nom pour l'activité");
    }*/
   
  } 

  nextStep(){
    this.stepstyle = 2;
  } 

  prevStep(){
    this.stepstyle = 1;
  } 

  goToDupp(){
    if (this.projetNameOne.trim().length === 0) {
      alert("Veuillez nommer le dossier avant");
    } else {
      //this.projectId = projectId;
      this.createProjectMode = 4 ;
      this.groupselected = 0;
      this.projectId = null;
      this.addingMember = [];
      this.mailInputShow = 0;
      this.inputemail ='';
      //this.loadMembers(projectId);
    }
  }

  goToGroup(projectId){
    //this.projectId = projectId;
    this.createProjectMode = 4 ;
    this.loadMembers(projectId);
  }

  loadMembers(id: string){
    //TO HEEEERE redirection vers page map après sélection du projet
    this.authService.getDataDuplicated(id).subscribe(res => {
      //console.log('retour liste project!!! ');
      this.members = [];
      this.addingMember = [];
      this.members = this.members.concat(res['userProject']);
      this.tags = this.tags.concat(res['tag']);
      this.tags = this.tags.filter(tag => tag.libelle !== 'general');
      let userStatus = []; 
      let subjectGroup = []; 
        for (let index = 0; index < this.members.length; index++) {
          if(this.members[index]['user']){
            var user = this.members[index]['user'];
            var id = user.substr(user.lastIndexOf('/') + 1);
            userStatus.push(id);
            if(this.contacts.find(i => i.id === id)){
              this.addingMember.push(this.contacts.find(i => i.id === id));
            }  
          } else if (this.members[index]['email']){
            this.addingMember.push({"givenName": this.members[index]['email'].replace("/api/users/", ""), "fullName": this.members[index]['email'].replace("/api/users/", ""), "familyName": "", "interne": false}); 
          }
          if(index == this.members.length - 1){
            this.addingMember = this.addingMember.sort(function (a, b) {
              if (a.fullName && b.fullName && (a.fullName.toLowerCase() < b.fullName.toLowerCase())) { return -1; }
              if (a.fullName && b.fullName && (a.fullName.toLowerCase() > b.fullName.toLowerCase())) { return 1; }
              return 0;
            })
          }
        }
        
        this.userStatus = userStatus;
        for (let index = 0; index < this.tags.length; index++) {
          if(this.tags[index]['libelle']){
            var tag = this.tags[index]['libelle'];
            //var id = tag.substr(tag.lastIndexOf('/') + 1);
            subjectGroup.push(tag);
          }
        }
        this.subjectGroup = subjectGroup;
        this.createProjectMode = 103;
      //this.total_project = res['hydra:totalItems'];
    }); 
  }

  goToAddMember(){
    this.addSujet();
    this.createProjectMode = 3; 
  }

  goToGoal(){
    //console.log("Project ID go : "+this.projectDetails);
     if (this.hasMemberAdding == false) {
        this.showComfirmMessage = true;
     }
     else
     {
        this.createProjectMode = 4;
        this.showComfirmMessage = false; 
     }

  }

  goToDeadline(){
    this.createProjectMode = 3;
    //console.log(" goToDeadline ==> : "+this.createProjectMode);
  }

  addSujet(){
    if (this.newProjectSubject.trim().length > 0) {
      var newTheme = this.newProjectSubject; 
      this.arraySubject.push({"libelle":newTheme});
      this.firstFormGroup.patchValue({
        sujectList: this.arraySubject   
      });
      this.newProjectSubject = '';
    }
    //console.log('firstFormGroup value => ' , this.firstFormGroup.value);
  }

  deleteSuject(sujectItem){
    
    const index = this.arraySubject.indexOf(sujectItem, 0);
    if (index > -1) {
        this.arraySubject.splice(index, 1);
    }

    this.firstFormGroup.patchValue({
      sujectList: this.arraySubject   
    });
    
    //console.log('deleteSuject firstFormGroup value => ' , this.firstFormGroup.value);
  
  }

  goToProject(){
    //console.log("Project ID go : "+this.projectDetails);
     if (this.hasMemberAdding == false) {
        this.showComfirmMessage = true;
     }
     else
     {
        //this.dialogRef.close(this.projectDetails);
     }
    
  }

  getFormattedName(member: { givenName: string; familyName: string }): string {
    if(member.familyName){
      const firstInitial = member.familyName.charAt(0).toUpperCase();
      return `${member.givenName} .${firstInitial}`;
    } else return member.givenName;
  }

  fileChangeEvent(event: any): void {
    const dialogRef = this.dialog.open(croppedimagedialog, {
      width: '700px',
      data: {event: event}
    });

    dialogRef.afterClosed().subscribe(result => {
      if(result !== null) {
        this.img = result.event;
        const reader = new FileReader();
        this.imageFil = result.fileToReturn;
        /*
        var files = event.target.files;

        // loop through files
        for (var i = 0; i < files.length; i++) {
          this.imageFil = files[i];
        }
        this.imageFil = files[i];
        */

        reader.readAsDataURL(this.imageFil);
          
        reader.onload = () => {
          // need to run CD since file load runs outside of zone
          this.cd.markForCheck();
          //this.img = reader.result;
        }; 
      }
    });
      //this.imageChangedEvent = event;
  }

  openInvitations(){
    this.mailInputShow = 1;
    this.inputemail = '';
    this.contactemail = '';
  }

  hideMailInput(){
    this.mailInputShow = 0;
    this.inputemail = '';
    this.contactemail = '';
  }

  fctAddMember(){
      
    //this.showTool = false; 
    //this.messageService.setShowCreateProjectTuto(false);
    //this.messageService.setShowCreateProjectTutoIsFalse();
    this.memberdialog = 1;
    
    const dialogRef = this.dialog.open(dashboardmemberdialog, {
      panelClass: 'dashboarddialog-container',
      data: {idcompany: 1, companyUser: this.contacts}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.memberdialog = 0;
      this.mailadded = result;
      //this.fctAddByMailValue(this.mailadded);  
    });
    /*
    if (this.mailadded != ""){
      this.fctAddByMailValue(this.mailadded);
      this.mailadded = "";
    }*/
  }

  fctCheckMember(userInfo){ 
    if(this.addingMember && !this.addingMember.includes(userInfo)){
      this.fctAdMember(userInfo);
    } else this.fctRemoveUser(userInfo);
  }

  fctAdMember(userInfo){ 
    this.addingMember.push(userInfo);
    this.userStatus[userInfo['id']] = 'PENDING';
    this.hasMemberAdding = true;
    this.searchContact = "";
  }

  fctAdTag(userInfo){ 
    this.subjectGroup.push(userInfo);
  }

  fctAdTagRow(){ 
    if (this.tagFormControl.value == '') {
      return;
    }
    var result = this.tagFormControl.value;
    this.subjectGroup.push(result);
    this.tags.push({"libelle": result});
    this.tagFormControl.reset();
  }

  fctRemoveTag(userInfo){
    const index = this.subjectGroup.indexOf(userInfo);
    if (index > -1) {
      this.subjectGroup.splice(index, 1);
    }
  }

  fctRemoveUser(userInfo){
    const index = this.addingMember.indexOf(userInfo);
    if (index > -1) {
      this.addingMember.splice(index, 1);
      delete this.userStatus[userInfo['id']];
      if (this.addingMember.length > 0) {
       this.hasMemberAdding = true;
      }
      else
      {
        this.hasMemberAdding = false;
      }
      this.searchContact = "";
    }
  }

  getAvatarlUrl(avatarLink){
    return environment.server_url+avatarLink;
  }

  openDialogInfo(){
    //console.log(' dans la fonction openDialogInfo');
    const dialogRef = this.dialog.open(tutoCreateProjectdialog, {
      width: '850px',
      data:{}
    });
    dialogRef.afterClosed().subscribe(result => {
    })
  }

}


@Component({
  selector: 'tutoCreateProjectdialog',
  templateUrl: 'tutoCreateProjectdialog.html',
   styleUrls: ['tutoCreateProjectdialog.scss']
})
export class tutoCreateProjectdialog implements OnInit{
  lang='fr';

  constructor(
    public dialogRef: MatDialogRef<tutoCreateProjectdialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private authService: AuthService,
    private messageService: MessageService,
    private _formBuilder: FormBuilder) {
     
  }

  ngOnInit() {
    this.messageService.getTranslate().subscribe((data) => {
      this.lang= data;
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}



@Component({
  selector: 'dashboardmemberdialog.component',
  templateUrl: 'dashboardmemberdialog.component.html',
   styleUrls: ['dashboardmemberdialog.component.scss']
})
export class dashboardmemberdialog implements OnInit{
  

  //@ViewChild('stepper') stepper: MatStepper;
  @ViewChild('addProjectForm', {static: true}) addProjectForm;
  firstFormGroup: FormGroup;
  addingMember = [];
  hasMemberAdding = false;
  projectUsers = [];
  userStatus = [];
  subjectGroup = [];
  projectId = null;
  projects: Array<any> = [];
  members: Array<any> = [];
  tags: Array<any> = [];
  projectDetails = null;
  contacts = [];
  searchContact: any;
  arrayEmailInvitation = [];
  arrayEmailInvitationWithId = [];
  arraySubject = [];
  groupselected = 0;
  public projectCtrl: FormControl = new FormControl();
  saveProject = null;
  firstLoad = false;
  newProjectSubject = '';
  currenteDate: any;
  showComfirmMessage = false;
  protected _onDestroy = new Subject<void>();
  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  tagFormControl = new FormControl('', [
    Validators.required,
    Validators.email,
  ]);

  createProjectMode = 1;
  dupplicatestyle = 0;
  stepstyle = 0;
  projectFilter = "0";
  typeproject = '0';
  duppselected = 1;

  constructor(
    public dialogRef: MatDialogRef<dashboarddialogCompo>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private authService: AuthService,
    private translate: TranslateService,
    location: Location, 
    private messageService: MessageService,
    public dialog: MatDialog,
    private _formBuilder: FormBuilder) {

      /*this.authService.getContacts().subscribe( dataContact => {
        this.contacts = dataContact['hydra:member'];
      });*/
      this.contacts = [];
      this.projects = data.projects;

      /*
      let userStatus = []; 
        for (let index = 0; index < this.projectUsers.length; index++) {
          if(this.projectUsers[index]['user'])
          userStatus[this.projectUsers[index]['user']['id']] = this.projectUsers[index]['status'];
        }
      this.userStatus = userStatus;*/
      
    }

    ngOnDestroy() {
      this._onDestroy.next();
      this._onDestroy.complete();
    }

    ngOnInit() {
      this.arrayEmailInvitation = [];
      this.arrayEmailInvitationWithId = [];
      this.addingMember = [];
      this.createProjectMode = 1;
      this.currenteDate = new Date();
      this.firstFormGroup = this._formBuilder.group({
        projetName: ['', Validators.required],
        clickCreate: ['', [Validators.required, Validators.requiredTrue]],
        objectif: [''],
        deadLine: [''],
        sujectList: [[]]
      });

      this.messageService.getTranslate().subscribe((data) => {
        this.setVar();
        this.setTheGuide();
      });
    }

    setVar(){
      
    }
  
  
    setTheGuide(){
      setTimeout(() => {}, 2000);
    }


  fctAddcontactByMail() {

    // stop here if form is invalid
    if (this.emailFormControl.status == 'INVALID') {
      return;
    }

    var result = this.emailFormControl.value;

 
     this.authService.getUserInfo(result).subscribe(
        res => {
          
          var arrayUser = res["hydra:member"];
          
          if (arrayUser.length > 0) {
            var newUser = arrayUser[0];
            this.addingMember.push(newUser);
            this.userStatus[newUser['id']] = 'PENDING';
            this.hasMemberAdding = true;
            this.emailFormControl.reset();
            this.arrayEmailInvitationWithId.push(result);  
          }
          else
          {
            this.arrayEmailInvitation.push(result);   
            this.hasMemberAdding = true;
            this.emailFormControl.reset();
          }
          
          this.searchContact = "";
         
        },
        (error) => {
          alert('Erreur ! : ' + error)
        }
      );

  }

  validate(){
    if (this.firstFormGroup.get('projetName').value.trim().length > 0 ){
      this.projectDetails = this.firstFormGroup.get('projetName').value;
      this.dialogRef.close(this.projectDetails);
    }
    
    
    
    
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


  nextStep(){
    this.stepstyle = 2;
  } 

  prevStep(){
    this.stepstyle = 1;
  } 

  goToProject(){
    //console.log("Project ID go : "+this.projectDetails);
     if (this.hasMemberAdding == false) {
        this.showComfirmMessage = true;
     }
     else
     {
        this.dialogRef.close(this.projectDetails);
     }
    
  }
/*
  fctAdMember(userInfo){ 
    this.addingMember.push(userInfo);
    this.userStatus[userInfo['id']] = 'PENDING';
    this.hasMemberAdding = true;
    this.searchContact = "";
  }*/


  fctAddMember(){
      
    //this.showTool = false; 
    //this.messageService.setShowCreateProjectTuto(false);
    //this.messageService.setShowCreateProjectTutoIsFalse();
    const dialogRef = this.dialog.open(addMemberCompany, {
      width: '700px',
      data: {idcompany: 1, companyUser: this.contacts}
    });

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed result add membre '+result);    
    });
  }


}

@Component({
  selector: 'app-notifdialog',
  templateUrl: 'notifdialog.component.html',
   styleUrls: ['notifdialog.component.scss']
})
export class notifDialog implements OnInit{
  stepMode = 1;
  @Output() notifQuit = new EventEmitter<any>();
  //@Input() notif_desabled: boolean;


  @Input() NOTIF_ALL_ENABLE: boolean = false;
  @Output() notifAllEnableChange = new EventEmitter<boolean>();

  NOTIF_INV_EMAIL: boolean = true;
  NOTIF_INV_PUSH: boolean = true;
  NOTIF_INV_SON: boolean = true;
  NOTIF_INSTANT_EMAIL: boolean = true;
  NOTIF_INSTANT_PUSH: boolean = true;
  NOTIF_INSTANT_SON: boolean = true;
  NOTIF_STRUCT_REC_EMAIL: boolean = true;
  NOTIF_STRUCT_REC_PUSH: boolean = true;
  NOTIF_STRUCT_REC_SON: boolean = true;
  NOTIF_STRUCT_COPY_EMAIL: boolean = true;
  NOTIF_STRUCT_COPY_PUSH: boolean = true;
  NOTIF_STRUCT_COPY_SON: boolean = true;
  NOTIF_STRUCT_COM_EMAIL: boolean = true;
  NOTIF_STRUCT_COM_PUSH: boolean = true;
  NOTIF_STRUCT_COM_SON: boolean = true;

  constructor(
    private authService: AuthService,
    public dialog: MatDialog,
    private cd: ChangeDetectorRef,
    private socketService: SocketService,
    private _formBuilder: FormBuilder) {
      
  }

  ngOnInit() {
    //this.notifsound = this.messageService.getSound();
    /*
		this.authService.getNotificationSetting().subscribe(
		  res => {  
		  	//this.showLoadbar = false;
		    var setting = res['hydra:member'];
		    if (setting.length > 0) {
		    	for (var i = 0; i < setting.length; i++) {
		    		if(setting[i].propertyID == 'NOTIF_ALL_ENABLE'){
		    			this.NOTIF_ALL_ENABLE = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_EMAIL'){
		    			this.NOTIF_INV_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_PUSH'){
		    			this.NOTIF_INV_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INV_SON'){
		    			this.NOTIF_INV_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_EMAIL'){
		    			this.NOTIF_INSTANT_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_PUSH'){
		    			this.NOTIF_INSTANT_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_INSTANT_SON'){
		    			this.NOTIF_INSTANT_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_EMAIL'){
		    			this.NOTIF_STRUCT_REC_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_PUSH'){
		    			this.NOTIF_STRUCT_REC_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_REC_SON'){
		    			this.NOTIF_STRUCT_REC_SON = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_EMAIL'){
		    			this.NOTIF_STRUCT_COPY_EMAIL = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_PUSH'){
		    			this.NOTIF_STRUCT_COPY_PUSH = setting[i].value ? true : false;
		    		}
            if(setting[i].propertyID == 'NOTIF_STRUCT_COPY_SON'){
		    			this.NOTIF_STRUCT_COPY_SON = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_EMAIL'){
		    			this.NOTIF_STRUCT_COM_EMAIL = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_PUSH'){
		    			this.NOTIF_STRUCT_COM_PUSH = setting[i].value ? true : false;
		    		}
		    		if(setting[i].propertyID == 'NOTIF_STRUCT_COM_SON'){
		    			this.NOTIF_STRUCT_COM_SON = setting[i].value ? true : false;
		    		}	
		    	}
		    }
		    else
		    {
		    	this.NOTIF_ALL_ENABLE = false;
		    	this.NOTIF_INV_EMAIL = true;
		    	this.NOTIF_INV_PUSH = true;
		    	this.NOTIF_INV_SON = true;
		    	this.NOTIF_INSTANT_EMAIL = true;
		    	this.NOTIF_INSTANT_PUSH = true;
		    	this.NOTIF_INSTANT_SON = true;
		    	this.NOTIF_STRUCT_REC_EMAIL = true;
		    	this.NOTIF_STRUCT_REC_PUSH = true;
		    	this.NOTIF_STRUCT_REC_SON = true;
		    	this.NOTIF_STRUCT_COPY_EMAIL = true;
		    	this.NOTIF_STRUCT_COPY_PUSH = true;
		    	this.NOTIF_STRUCT_COPY_SON = true;
		    	this.NOTIF_STRUCT_COM_EMAIL = true;
		    	this.NOTIF_STRUCT_COM_PUSH = true;
		    	this.NOTIF_STRUCT_COM_SON = true;
		    }
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);*/
  }

  goBackNotifInit(){
    this.stepMode = 1;
  }

  goToStep(level = 0){
    if(level > 0) this.stepMode = level;
  }

  quitNotif(value = null){
    this.notifQuit.emit('param');
  }

  nextStep(){
    //this.step = 2;
  } 

  prevStep(){
    //this.step = 1;
  } 

  allDesable(value: boolean){
		this.NOTIF_ALL_ENABLE = !value;
		this.authService.notifEnable(!value,"NOTIF_ALL_ENABLE").subscribe(
		  res => {  
        this.notifAllEnableChange.emit(!value);
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  allEnable(value: boolean){
		this.NOTIF_ALL_ENABLE = value;
		this.authService.notifEnable(value,"NOTIF_ALL_ENABLE").subscribe(
		  res => {  
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  invEmailEnable(value: boolean){
		this.NOTIF_INV_EMAIL = value;
		this.authService.notifEnable(value,"NOTIF_INV_EMAIL").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  invPushEnable(value: boolean){
		this.NOTIF_INV_PUSH = value;
		this.authService.notifEnable(value,"NOTIF_INV_PUSH").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  invSonEnable(value: boolean){
		this.NOTIF_INV_SON = value;
		this.authService.notifEnable(value,"NOTIF_INV_SON").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  instantEmailEnable(value: boolean){
		this.NOTIF_INSTANT_EMAIL = value;
		this.authService.notifEnable(value,"NOTIF_INSTANT_EMAIL").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  instantPushEnable(value: boolean){
		this.NOTIF_INSTANT_PUSH = value;
		this.authService.notifEnable(value,"NOTIF_INSTANT_PUSH").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  instantSonEnable(value: boolean){
		this.NOTIF_INSTANT_SON = value;
		this.authService.notifEnable(value,"NOTIF_INSTANT_SON").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structRecEmailEnable(value: boolean){
		this.NOTIF_STRUCT_REC_EMAIL = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_REC_EMAIL").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structRecPushEnable(value: boolean){
		this.NOTIF_STRUCT_REC_PUSH = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_REC_PUSH").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structRecSonEnable(value: boolean){
		this.NOTIF_STRUCT_REC_SON = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_REC_SON").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structCopyEmailEnable(value: boolean){
		this.NOTIF_STRUCT_COPY_EMAIL = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COPY_EMAIL").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structCopyPushEnable(value: boolean){
		this.NOTIF_STRUCT_COPY_PUSH = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COPY_PUSH").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structCopySonEnable(value: boolean){
		this.NOTIF_STRUCT_COPY_SON = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COPY_SON").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structComEmailEnable(value: boolean){
		this.NOTIF_STRUCT_COM_EMAIL = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COM_EMAIL").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structComPushEnable(value: boolean){
		this.NOTIF_STRUCT_COM_PUSH = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COM_PUSH").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

  structComSonEnable(value: boolean){
		this.NOTIF_STRUCT_COM_SON = value;
		this.authService.notifEnable(value,"NOTIF_STRUCT_COM_SON").subscribe(
		  res => {  
		    //this.stepper.selectedIndex = 1;
		  },
		  (error) => {
		    alert('Erreur ! : ' + error)
		  }
		);	
	}

}

